var _g, _defs, _defs2, _feBlend, _feBlend2, _mask, _feBlend3, _feBlend4, _mask2, _feBlend5, _feBlend6, _mask3, _feBlend7, _feBlend8, _mask4, _feBlend9, _feBlend10, _mask5, _feBlend11, _feBlend12, _mask6, _feBlend13, _feBlend14, _mask7, _feBlend15, _feBlend16, _mask8, _feBlend17, _feBlend18, _mask9, _feBlend19, _feBlend20, _mask10, _feBlend21, _feBlend22, _mask11, _feBlend23, _feBlend24, _mask12, _feBlend25, _feBlend26, _mask13, _feBlend27, _feBlend28, _mask14, _feBlend29, _feBlend30, _mask15, _feBlend31, _feBlend32, _mask16, _feBlend33, _feBlend34, _mask17, _feBlend35, _feBlend36, _mask18, _feBlend37, _feBlend38, _mask19, _feBlend39, _feBlend40, _mask20, _feBlend41, _feBlend42, _mask21, _feBlend43, _feBlend44, _mask22, _feBlend45, _feBlend46, _mask23, _feBlend47, _feBlend48, _mask24, _feBlend49, _feBlend50, _mask25, _feBlend51, _feBlend52, _mask26, _feBlend53, _feBlend54, _mask27, _feBlend55, _feBlend56, _mask28, _feBlend57, _feBlend58, _mask29, _feBlend59, _feBlend60, _mask30, _feBlend61, _feBlend62, _mask31, _feBlend63, _feBlend64, _mask32, _feBlend65, _feBlend66, _mask33, _feBlend67, _feBlend68, _mask34, _feBlend69, _feBlend70, _mask35, _feBlend71, _feBlend72, _mask36, _feBlend73, _feBlend74, _mask37, _feBlend75, _feBlend76, _mask38, _feBlend77, _feBlend78, _mask39, _feBlend79, _feBlend80, _mask40, _feBlend81, _feBlend82, _mask41, _feBlend83, _feBlend84, _mask42, _feBlend85, _feBlend86, _mask43, _feBlend87, _feBlend88, _mask44, _feBlend89, _feBlend90, _mask45, _feBlend91, _feBlend92, _mask46, _feBlend93, _feBlend94, _mask47, _feBlend95, _feBlend96, _mask48, _feBlend97, _feBlend98, _mask49, _feBlend99, _feBlend100, _mask50, _feBlend101, _feBlend102, _mask51, _feBlend103, _feBlend104, _mask52, _feBlend105, _feBlend106, _mask53, _feBlend107, _feBlend108, _mask54, _feBlend109, _feBlend110, _mask55, _feBlend111, _feBlend112, _mask56, _feBlend113, _feBlend114, _mask57, _feBlend115, _feBlend116, _mask58, _feBlend117, _feBlend118, _mask59, _feBlend119, _feBlend120, _mask60, _feBlend121, _feBlend122, _mask61, _feBlend123, _feBlend124, _mask62, _feBlend125, _feBlend126, _mask63, _feBlend127, _feBlend128, _mask64, _feBlend129, _feBlend130, _mask65, _feBlend131, _feBlend132, _mask66, _feBlend133, _feBlend134, _mask67, _feBlend135, _feBlend136, _mask68, _feBlend137, _feBlend138, _mask69, _feBlend139, _feBlend140, _mask70, _feBlend141, _feBlend142, _mask71, _feBlend143, _feBlend144, _mask72, _feBlend145, _feBlend146, _mask73, _feBlend147, _feBlend148, _mask74, _feBlend149, _feBlend150, _mask75, _feBlend151, _feBlend152, _mask76, _feBlend153, _feBlend154, _mask77, _feBlend155, _feBlend156, _mask78, _feBlend157, _feBlend158, _mask79, _feBlend159, _feBlend160, _mask80, _feBlend161, _feBlend162, _mask81, _feBlend163;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      "enableBackground": "new 0 0 1122 1122"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 561,
    cy: 597.88,
    r: 237.04
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      "overflow": "visible",
      "fill": "#191919"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081648577232511631320000000647562948834366131_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      "overflow": "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000117672439757847715720000015070915134857445257_",
    cx: 561,
    cy: 597.88,
    r: 237.04
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067219826029419433110000003492426435685847474_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000117672439757847715720000015070915134857445257_",
    style: {
      "overflow": "visible"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 398.16,
    y: 414.02,
    width: 169.52,
    height: 180.12
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 398.16,
    y: 414.02,
    width: 169.52,
    height: 180.12,
    id: "SVGID_00000142177912031940522700000010760519570203428484_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000101097522120045610630000005798146474830313901_",
    filterUnits: "userSpaceOnUse",
    x: 398.16,
    y: 414.02,
    width: 169.52,
    height: 180.12
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 398.16,
    y: 414.02,
    width: 169.52,
    height: 180.12,
    id: "SVGID_00000142177912031940522700000010760519570203428484_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000146493720939251320190000008611990986277273493_",
    cx: 520.0682,
    cy: 495.9653,
    r: 87.4542,
    gradientTransform: "matrix(0.9995 0.0308 -0.0308 0.9995 -21.6124 -7.6531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000142177912031940522700000010760519570203428484_)",
      "fill": "url(#SVGID_00000146493720939251320190000008611990986277273493_)"
    },
    d: " M566.18,594.14c-0.4,0-0.8-0.16-1.09-0.47L398.57,416.55c-0.57-0.6-0.54-1.55,0.07-2.12c0.6-0.57,1.55-0.54,2.12,0.07 l166.52,177.12c0.57,0.6,0.54,1.55-0.07,2.12C566.92,594.01,566.55,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072983263044568051970000008679287121473511061_",
    cx: 520.0682,
    cy: 495.9653,
    r: 87.4542,
    gradientTransform: "matrix(0.9995 0.0308 -0.0308 0.9995 -21.6124 -7.6531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000072983263044568051970000008679287121473511061_)"
    },
    d: " M566.18,594.14c-0.4,0-0.8-0.16-1.09-0.47L398.57,416.55c-0.57-0.6-0.54-1.55,0.07-2.12c0.6-0.57,1.55-0.54,2.12,0.07 l166.52,177.12c0.57,0.6,0.54,1.55-0.07,2.12C566.92,594.01,566.55,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000145022693196729106640000009186926103133474176_",
    filterUnits: "userSpaceOnUse",
    x: 379.5,
    y: 358.21,
    width: 188.19,
    height: 235.94
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 379.5,
    y: 358.21,
    width: 188.19,
    height: 235.94,
    id: "SVGID_00000129171676025873164270000009569466215876484524_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000145022693196729106640000009186926103133474176_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000067938829902971568110000016516408538784840834_",
    filterUnits: "userSpaceOnUse",
    x: 379.5,
    y: 358.21,
    width: 188.19,
    height: 235.94
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 379.5,
    y: 358.21,
    width: 188.19,
    height: 235.94,
    id: "SVGID_00000129171676025873164270000009569466215876484524_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000151543580633709507940000008982992551492744890_",
    cx: 509.8859,
    cy: 468.3654,
    r: 106.7103,
    gradientTransform: "matrix(0.9995 0.0308 -0.0308 0.9995 -21.6124 -7.6531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000129171676025873164270000009569466215876484524_)",
      "fill": "url(#SVGID_00000151543580633709507940000008982992551492744890_)"
    },
    d: " M566.19,594.15c-0.44,0-0.88-0.19-1.17-0.57L379.82,360.65c-0.52-0.65-0.41-1.59,0.24-2.11c0.65-0.52,1.59-0.41,2.11,0.24 l185.19,232.94c0.52,0.65,0.41,1.59-0.24,2.11C566.85,594.05,566.52,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000060009494523865354810000011429665080830578337_",
    cx: 509.8859,
    cy: 468.3654,
    r: 106.7103,
    gradientTransform: "matrix(0.9995 0.0308 -0.0308 0.9995 -21.6124 -7.6531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000060009494523865354810000011429665080830578337_)"
    },
    d: " M566.19,594.15c-0.44,0-0.88-0.19-1.17-0.57L379.82,360.65c-0.52-0.65-0.41-1.59,0.24-2.11c0.65-0.52,1.59-0.41,2.11,0.24 l185.19,232.94c0.52,0.65,0.41,1.59-0.24,2.11C566.85,594.05,566.52,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147205912333710893460000004349642437373774271_",
    filterUnits: "userSpaceOnUse",
    x: 429.67,
    y: 388.97,
    width: 138.02,
    height: 205.17
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 429.67,
    y: 388.97,
    width: 138.02,
    height: 205.17,
    id: "SVGID_00000076563815848772044570000000076357425947818663_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000147205912333710893460000004349642437373774271_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000114064730367861586290000016280709168999644093_",
    filterUnits: "userSpaceOnUse",
    x: 429.67,
    y: 388.97,
    width: 138.02,
    height: 205.17
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 429.67,
    y: 388.97,
    width: 138.02,
    height: 205.17,
    id: "SVGID_00000076563815848772044570000000076357425947818663_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000062153284888759405900000017346738695528504210_",
    cx: 632.6545,
    cy: 482.7607,
    r: 87.4499,
    gradientTransform: "matrix(0.9935 0.1135 -0.1135 0.9935 -75.0745 -59.8712)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000076563815848772044570000000076357425947818663_)",
      "fill": "url(#SVGID_00000062153284888759405900000017346738695528504210_)"
    },
    d: " M566.18,594.14c-0.48,0-0.96-0.23-1.25-0.67L429.92,391.31c-0.46-0.69-0.28-1.62,0.41-2.08c0.69-0.46,1.62-0.27,2.08,0.41 l135.02,202.17c0.46,0.69,0.28,1.62-0.41,2.08C566.76,594.06,566.47,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000073706246376015459550000005467672709441856906_",
    cx: 632.6545,
    cy: 482.7607,
    r: 87.4499,
    gradientTransform: "matrix(0.9935 0.1135 -0.1135 0.9935 -75.0745 -59.8712)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000073706246376015459550000005467672709441856906_)"
    },
    d: " M566.18,594.14c-0.48,0-0.96-0.23-1.25-0.67L429.92,391.31c-0.46-0.69-0.28-1.62,0.41-2.08c0.69-0.46,1.62-0.27,2.08,0.41 l135.02,202.17c0.46,0.69,0.28,1.62-0.41,2.08C566.76,594.06,566.47,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000013897105500755107570000010168557969597291417_",
    filterUnits: "userSpaceOnUse",
    x: 420.47,
    y: 330.85,
    width: 147.22,
    height: 263.31
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 420.47,
    y: 330.85,
    width: 147.22,
    height: 263.31,
    id: "SVGID_00000067207731940480941030000009998187481216283009_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000013897105500755107570000010168557969597291417_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000002383819541002678070000007299522992983954359_",
    filterUnits: "userSpaceOnUse",
    x: 420.47,
    y: 330.85,
    width: 147.22,
    height: 263.31
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 420.47,
    y: 330.85,
    width: 147.22,
    height: 263.31,
    id: "SVGID_00000067207731940480941030000009998187481216283009_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120536923556201621920000013461756960779125395_",
    cx: 718.3412,
    cy: 447.9014,
    r: 106.7119,
    gradientTransform: "matrix(0.9807 0.1953 -0.1953 0.9807 -122.921 -117.0487)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000067207731940480941030000009998187481216283009_)",
      "fill": "url(#SVGID_00000120536923556201621920000013461756960779125395_)"
    },
    d: " M566.19,594.15c-0.53,0-1.04-0.28-1.31-0.77L420.66,333.07c-0.4-0.72-0.14-1.64,0.59-2.04c0.72-0.4,1.64-0.14,2.04,0.59 L567.5,591.93c0.4,0.72,0.14,1.64-0.59,2.04C566.69,594.09,566.44,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000092414340292371205780000008432217430539867280_",
    cx: 718.3412,
    cy: 447.9014,
    r: 106.7119,
    gradientTransform: "matrix(0.9807 0.1953 -0.1953 0.9807 -122.921 -117.0487)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000092414340292371205780000008432217430539867280_)"
    },
    d: " M566.19,594.15c-0.53,0-1.04-0.28-1.31-0.77L420.66,333.07c-0.4-0.72-0.14-1.64,0.59-2.04c0.72-0.4,1.64-0.14,2.04,0.59 L567.5,591.93c0.4,0.72,0.14,1.64-0.59,2.04C566.69,594.09,566.44,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000101797170326651922940000001621592688862448550_",
    filterUnits: "userSpaceOnUse",
    x: 464.88,
    y: 369.47,
    width: 102.81,
    height: 224.68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 464.88,
    y: 369.47,
    width: 102.81,
    height: 224.68,
    id: "SVGID_00000072992595282190126160000011556473110479850377_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000101797170326651922940000001621592688862448550_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000059312182513333296220000006285639796998344583_",
    filterUnits: "userSpaceOnUse",
    x: 464.88,
    y: 369.47,
    width: 102.81,
    height: 224.68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 464.88,
    y: 369.47,
    width: 102.81,
    height: 224.68,
    id: "SVGID_00000072992595282190126160000011556473110479850377_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000149356863547915155820000010740734095004632746_",
    cx: 837.6235,
    cy: 445.5419,
    r: 87.4479,
    gradientTransform: "matrix(0.9612 0.2758 -0.2758 0.9612 -165.9639 -177.4673)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000072992595282190126160000011556473110479850377_)",
      "fill": "url(#SVGID_00000149356863547915155820000010740734095004632746_)"
    },
    d: " M566.18,594.14c-0.57,0-1.12-0.33-1.37-0.88l-99.81-221.68c-0.34-0.76,0-1.64,0.75-1.98c0.76-0.34,1.64,0,1.98,0.75 l99.81,221.68c0.34,0.76,0,1.64-0.75,1.98C566.6,594.1,566.39,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000052094014887819482870000002697583208707666609_",
    cx: 837.6235,
    cy: 445.5419,
    r: 87.4479,
    gradientTransform: "matrix(0.9612 0.2758 -0.2758 0.9612 -165.9639 -177.4673)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000052094014887819482870000002697583208707666609_)"
    },
    d: " M566.18,594.14c-0.57,0-1.12-0.33-1.37-0.88l-99.81-221.68c-0.34-0.76,0-1.64,0.75-1.98c0.76-0.34,1.64,0,1.98,0.75l99.81,221.68 c0.34,0.76,0,1.64-0.75,1.98C566.6,594.1,566.39,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000097462531244012274540000005911540345650716802_",
    filterUnits: "userSpaceOnUse",
    x: 465.4,
    y: 310.62,
    width: 102.29,
    height: 283.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 465.4,
    y: 310.62,
    width: 102.29,
    height: 283.54,
    id: "SVGID_00000114793437528926217960000000481706318972255147_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000097462531244012274540000005911540345650716802_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000115503537535852021560000003180928157466667963_",
    filterUnits: "userSpaceOnUse",
    x: 465.4,
    y: 310.62,
    width: 102.29,
    height: 283.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 465.4,
    y: 310.62,
    width: 102.29,
    height: 283.54,
    id: "SVGID_00000114793437528926217960000000481706318972255147_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088102706382257431360000011314680550926360761_",
    cx: 919.8904,
    cy: 392.3144,
    r: 106.7031,
    gradientTransform: "matrix(0.9351 0.3545 -0.3545 0.9351 -204.5681 -240.5688)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000114793437528926217960000000481706318972255147_)",
      "fill": "url(#SVGID_00000088102706382257431360000011314680550926360761_)"
    },
    d: " M566.19,594.15c-0.62,0-1.2-0.38-1.41-1l-99.29-280.54c-0.28-0.78,0.13-1.64,0.91-1.91c0.78-0.28,1.64,0.13,1.91,0.91 l99.29,280.54c0.28,0.78-0.13,1.64-0.91,1.91C566.52,594.13,566.36,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000037657729758053755720000003614731974119819697_",
    cx: 919.8904,
    cy: 392.3144,
    r: 106.7031,
    gradientTransform: "matrix(0.9351 0.3545 -0.3545 0.9351 -204.5681 -240.5688)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000037657729758053755720000003614731974119819697_)"
    },
    d: " M566.19,594.15c-0.62,0-1.2-0.38-1.41-1l-99.29-280.54c-0.28-0.78,0.13-1.64,0.91-1.91c0.78-0.28,1.64,0.13,1.91,0.91 l99.29,280.54c0.28,0.78-0.13,1.64-0.91,1.91C566.52,594.13,566.36,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147186005506806961470000016778621698912707993_",
    filterUnits: "userSpaceOnUse",
    x: 502.82,
    y: 356.03,
    width: 64.86,
    height: 238.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 502.82,
    y: 356.03,
    width: 64.86,
    height: 238.11,
    id: "SVGID_00000115481890800910566040000012386277118431959941_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000147186005506806961470000016778621698912707993_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000118371035811618122670000013633987163522669190_",
    filterUnits: "userSpaceOnUse",
    x: 502.82,
    y: 356.03,
    width: 64.86,
    height: 238.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 502.82,
    y: 356.03,
    width: 64.86,
    height: 238.11,
    id: "SVGID_00000115481890800910566040000012386277118431959941_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000094578347615083544390000006930947099335482248_",
    cx: 1034.8861,
    cy: 373.5235,
    r: 87.4468,
    gradientTransform: "matrix(0.9025 0.4307 -0.4307 0.9025 -237.8548 -307.7425)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000115481890800910566040000012386277118431959941_)",
      "fill": "url(#SVGID_00000094578347615083544390000006930947099335482248_)"
    },
    d: " M566.18,594.14c-0.67,0-1.27-0.45-1.45-1.12l-61.86-235.11c-0.21-0.8,0.27-1.62,1.07-1.83c0.8-0.21,1.62,0.27,1.83,1.07 l61.86,235.11c0.21,0.8-0.27,1.62-1.07,1.83C566.44,594.13,566.31,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000101101594532825878560000005860216261077332664_",
    cx: 1034.8861,
    cy: 373.5235,
    r: 87.4468,
    gradientTransform: "matrix(0.9025 0.4307 -0.4307 0.9025 -237.8548 -307.7425)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000101101594532825878560000005860216261077332664_)"
    },
    d: " M566.18,594.14c-0.67,0-1.27-0.45-1.45-1.12l-61.86-235.11c-0.21-0.8,0.27-1.62,1.07-1.83c0.8-0.21,1.62,0.27,1.83,1.07 l61.86,235.11c0.21,0.8-0.27,1.62-1.07,1.83C566.44,594.13,566.31,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147202203759405227450000008183038740866159794_",
    filterUnits: "userSpaceOnUse",
    x: 513.05,
    y: 298.08,
    width: 54.64,
    height: 296.07
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 513.05,
    y: 298.08,
    width: 54.64,
    height: 296.07,
    id: "SVGID_00000116198421459262743220000014853804628700690603_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000147202203759405227450000008183038740866159794_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000045620564868534924600000000917307317165611936_",
    filterUnits: "userSpaceOnUse",
    x: 513.05,
    y: 298.08,
    width: 54.64,
    height: 296.07
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 513.05,
    y: 298.08,
    width: 54.64,
    height: 296.07,
    id: "SVGID_00000116198421459262743220000014853804628700690603_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000112590841080953449930000006727554662506561717_",
    cx: 1109.8843,
    cy: 305.4545,
    r: 106.7045,
    gradientTransform: "matrix(0.8638 0.5039 -0.5039 0.8638 -264.4277 -377.0061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000116198421459262743220000014853804628700690603_)",
      "fill": "url(#SVGID_00000112590841080953449930000006727554662506561717_)"
    },
    d: " M566.19,594.15c-0.71,0-1.35-0.51-1.48-1.24l-51.63-293.07c-0.14-0.82,0.4-1.59,1.22-1.74c0.82-0.14,1.59,0.4,1.74,1.22 l51.63,293.07c0.14,0.82-0.4,1.59-1.22,1.74C566.36,594.15,566.27,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000086670786920202976740000005600820429278372753_",
    cx: 1109.8843,
    cy: 305.4545,
    r: 106.7045,
    gradientTransform: "matrix(0.8638 0.5039 -0.5039 0.8638 -264.4277 -377.0061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000086670786920202976740000005600820429278372753_)"
    },
    d: " M566.19,594.15c-0.71,0-1.35-0.51-1.48-1.24l-51.63-293.07c-0.14-0.82,0.4-1.59,1.22-1.74c0.82-0.14,1.59,0.4,1.74,1.22 l51.63,293.07c0.14,0.82-0.4,1.59-1.22,1.74C566.36,594.15,566.27,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000123426405694165758260000012189966184440506300_",
    filterUnits: "userSpaceOnUse",
    x: 542.47,
    y: 349.05,
    width: 25.22,
    height: 245.09
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 542.47,
    y: 349.05,
    width: 25.22,
    height: 245.09,
    id: "SVGID_00000039832719738302841430000015142496694212796863_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000123426405694165758260000012189966184440506300_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000123428917349644188380000011842098319099941514_",
    filterUnits: "userSpaceOnUse",
    x: 542.47,
    y: 349.05,
    width: 25.22,
    height: 245.09
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 542.47,
    y: 349.05,
    width: 25.22,
    height: 245.09,
    id: "SVGID_00000039832719738302841430000015142496694212796863_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000079484853347345028670000015730890302589731719_",
    cx: 1216.7616,
    cy: 270.917,
    r: 87.4432,
    gradientTransform: "matrix(0.8191 0.5737 -0.5737 0.8191 -286.1513 -448.3659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000039832719738302841430000015142496694212796863_)",
      "fill": "url(#SVGID_00000079484853347345028670000015730890302589731719_)"
    },
    d: " M566.18,594.14c-0.77,0-1.42-0.59-1.49-1.36l-22.22-242.09c-0.08-0.82,0.53-1.55,1.36-1.63c0.8-0.08,1.55,0.53,1.63,1.36 l22.22,242.09c0.08,0.82-0.53,1.55-1.36,1.63C566.27,594.14,566.23,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078754534979795520970000014923116222990597015_",
    cx: 1216.7616,
    cy: 270.917,
    r: 87.4432,
    gradientTransform: "matrix(0.8191 0.5737 -0.5737 0.8191 -286.1513 -448.3659)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000078754534979795520970000014923116222990597015_)"
    },
    d: " M566.18,594.14c-0.77,0-1.42-0.59-1.49-1.36l-22.22-242.09c-0.08-0.82,0.53-1.55,1.36-1.63c0.8-0.08,1.55,0.53,1.63,1.36 l22.22,242.09c0.08,0.82-0.53,1.55-1.36,1.63C566.27,594.14,566.23,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000152258075717864018430000015284940286288185514_",
    filterUnits: "userSpaceOnUse",
    x: 564.41,
    y: 293.58,
    width: 3.28,
    height: 300.58
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.41,
    y: 293.58,
    width: 3.28,
    height: 300.58,
    id: "SVGID_00000179630988322787230940000001767136623998172842_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000152258075717864018430000015284940286288185514_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000070080632786993833400000011859061129194863250_",
    filterUnits: "userSpaceOnUse",
    x: 564.41,
    y: 293.58,
    width: 3.28,
    height: 300.58
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.41,
    y: 293.58,
    width: 3.28,
    height: 300.58,
    id: "SVGID_00000179630988322787230940000001767136623998172842_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000134218857969652173850000017348027528524879252_",
    cx: 1284.136,
    cy: 187.5679,
    r: 106.7031,
    gradientTransform: "matrix(0.7688 0.6395 -0.6395 0.7688 -301.2447 -521.5431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000179630988322787230940000001767136623998172842_)",
      "fill": "url(#SVGID_00000134218857969652173850000017348027528524879252_)"
    },
    d: " M566.19,594.15c-0.83,0-1.5-0.67-1.5-1.5l-0.28-297.58c0-0.83,0.67-1.5,1.5-1.5h0c0.83,0,1.5,0.67,1.5,1.5l0.28,297.58 C567.69,593.48,567.02,594.15,566.19,594.15L566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000144305090080658492840000017743690775872658317_",
    cx: 1284.136,
    cy: 187.5679,
    r: 106.7031,
    gradientTransform: "matrix(0.7688 0.6395 -0.6395 0.7688 -301.2447 -521.5431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000144305090080658492840000017743690775872658317_)"
    },
    d: " M566.19,594.15c-0.83,0-1.5-0.67-1.5-1.5l-0.28-297.58c0-0.83,0.67-1.5,1.5-1.5h0c0.83,0,1.5,0.67,1.5,1.5l0.28,297.58 C567.69,593.48,567.02,594.15,566.19,594.15L566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000155113164208178918760000001563332231429037230_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 348.7,
    width: 21.04,
    height: 245.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 348.7,
    width: 21.04,
    height: 245.44,
    id: "SVGID_00000025441684390420645030000005899842651169736122_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000155113164208178918760000001563332231429037230_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000050632533929350319920000011267702494855579059_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 348.7,
    width: 21.04,
    height: 245.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 348.7,
    width: 21.04,
    height: 245.44,
    id: "SVGID_00000025441684390420645030000005899842651169736122_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026126336451387380300000011933937332185422246_",
    cx: 1379.7567,
    cy: 139.4224,
    r: 87.4451,
    gradientTransform: "matrix(0.7132 0.701 -0.701 0.7132 -311.1081 -595.2233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000025441684390420645030000005899842651169736122_)",
      "fill": "url(#SVGID_00000026126336451387380300000011933937332185422246_)"
    },
    d: " M566.18,594.14c-0.04,0-0.08,0-0.11,0c-0.83-0.06-1.45-0.78-1.38-1.61l18.04-242.44c0.06-0.83,0.78-1.46,1.61-1.38 c0.83,0.06,1.45,0.78,1.38,1.61l-18.04,242.44C567.62,593.54,566.96,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000054975727860308197870000006719549695361197481_",
    cx: 1379.7567,
    cy: 139.4224,
    r: 87.4451,
    gradientTransform: "matrix(0.7132 0.701 -0.701 0.7132 -311.1081 -595.2233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000054975727860308197870000006719549695361197481_)"
    },
    d: " M566.18,594.14c-0.04,0-0.08,0-0.11,0c-0.83-0.06-1.45-0.78-1.38-1.61l18.04-242.44c0.06-0.83,0.78-1.46,1.61-1.38 c0.83,0.06,1.45,0.78,1.38,1.61l-18.04,242.44C567.62,593.54,566.96,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000025404265241665994000000005470075899086925454_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 297.23,
    width: 49.57,
    height: 296.92
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 297.23,
    width: 49.57,
    height: 296.92,
    id: "SVGID_00000053515350791374075040000015149012247128315049_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000025404265241665994000000005470075899086925454_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000155846391116844691870000003681942684741642134_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 297.23,
    width: 49.57,
    height: 296.92
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 297.23,
    width: 49.57,
    height: 296.92,
    id: "SVGID_00000053515350791374075040000015149012247128315049_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173857073107770758240000012975290946775355801_",
    cx: 1435.188,
    cy: 43.6838,
    r: 106.7088,
    gradientTransform: "matrix(0.6527 0.7576 -0.7576 0.6527 -314.178 -670.1175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000053515350791374075040000015149012247128315049_)",
      "fill": "url(#SVGID_00000173857073107770758240000012975290946775355801_)"
    },
    d: " M566.19,594.15c-0.08,0-0.16-0.01-0.24-0.02c-0.82-0.13-1.38-0.9-1.25-1.72l46.57-293.92c0.13-0.82,0.9-1.38,1.72-1.25 c0.82,0.13,1.38,0.9,1.25,1.72l-46.57,293.92C567.55,593.63,566.92,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000161622647123898723190000009461561757655184054_",
    cx: 1435.188,
    cy: 43.6838,
    r: 106.7088,
    gradientTransform: "matrix(0.6527 0.7576 -0.7576 0.6527 -314.178 -670.1175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000161622647123898723190000009461561757655184054_)"
    },
    d: " M566.19,594.15c-0.08,0-0.16-0.01-0.24-0.02c-0.82-0.13-1.38-0.9-1.25-1.72l46.57-293.92c0.13-0.82,0.9-1.38,1.72-1.25 c0.82,0.13,1.38,0.9,1.25,1.72l-46.57,293.92C567.55,593.63,566.92,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000071546873807947611790000015823603665021160360_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 355,
    width: 60.79,
    height: 239.14
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 355,
    width: 60.79,
    height: 239.14,
    id: "SVGID_00000178927764608264845650000015221339628822336145_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000071546873807947611790000015823603665021160360_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000107555028101198700490000004135593450171903138_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 355,
    width: 60.79,
    height: 239.14
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 355,
    width: 60.79,
    height: 239.14,
    id: "SVGID_00000178927764608264845650000015221339628822336145_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000221537873554495430000000913826318113091263_",
    cx: 1519.2943,
    cy: -17.5242,
    r: 87.4454,
    gradientTransform: "matrix(0.5877 0.8091 -0.8091 0.5877 -311.9896 -744.3898)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000178927764608264845650000015221339628822336145_)",
      "fill": "url(#SVGID_00000000221537873554495430000000913826318113091263_)"
    },
    d: " M566.18,594.14c-0.12,0-0.24-0.01-0.36-0.04c-0.8-0.2-1.3-1.01-1.1-1.81l57.79-236.14c0.2-0.8,1.01-1.3,1.81-1.1 c0.8,0.2,1.3,1.01,1.1,1.81L567.64,593C567.47,593.68,566.86,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000063619958739942462080000011046714685611192974_",
    cx: 1519.2943,
    cy: -17.5242,
    r: 87.4454,
    gradientTransform: "matrix(0.5877 0.8091 -0.8091 0.5877 -311.9896 -744.3898)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000063619958739942462080000011046714685611192974_)"
    },
    d: " M566.18,594.14c-0.12,0-0.24-0.01-0.36-0.04c-0.8-0.2-1.3-1.01-1.1-1.81l57.79-236.14c0.2-0.8,1.01-1.3,1.81-1.1 c0.8,0.2,1.3,1.01,1.1,1.81L567.64,593C567.47,593.68,566.86,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000038412657116070161120000003138326385402004101_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 308.95,
    width: 97.43,
    height: 285.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 308.95,
    width: 97.43,
    height: 285.21,
    id: "SVGID_00000043443231418590992040000001555484471244909964_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000038412657116070161120000003138326385402004101_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000078752096539859516140000007873598806219471003_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 308.95,
    width: 97.43,
    height: 285.21
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 308.95,
    width: 97.43,
    height: 285.21,
    id: "SVGID_00000043443231418590992040000001555484471244909964_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000065756690892937202670000008114563522030556090_",
    cx: 1561.3027,
    cy: -123.7856,
    r: 106.7129,
    gradientTransform: "matrix(0.5187 0.8549 -0.8549 0.5187 -302.268 -819.0006)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000043443231418590992040000001555484471244909964_)",
      "fill": "url(#SVGID_00000065756690892937202670000008114563522030556090_)"
    },
    d: " M566.19,594.15c-0.16,0-0.32-0.02-0.48-0.08c-0.79-0.26-1.21-1.11-0.95-1.9l94.43-282.21c0.26-0.79,1.11-1.21,1.9-0.95 c0.79,0.26,1.21,1.11,0.95,1.9l-94.43,282.21C567.4,593.76,566.82,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000001638081943662628480000016563956418256760216_",
    cx: 1561.3027,
    cy: -123.7856,
    r: 106.7129,
    gradientTransform: "matrix(0.5187 0.8549 -0.8549 0.5187 -302.268 -819.0006)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000001638081943662628480000016563956418256760216_)"
    },
    d: " M566.19,594.15c-0.16,0-0.32-0.02-0.48-0.08c-0.79-0.26-1.21-1.11-0.95-1.9l94.43-282.21c0.26-0.79,1.11-1.21,1.9-0.95 c0.79,0.26,1.21,1.11,0.95,1.9l-94.43,282.21C567.4,593.76,566.82,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000168804559105586044270000013289609559055233688_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 367.78,
    width: 98.97,
    height: 226.37
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 367.78,
    width: 98.97,
    height: 226.37,
    id: "SVGID_00000146472667952286807260000012510606752196285068_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000168804559105586044270000013289609559055233688_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000112624227859409488860000012592164096065710486_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 367.78,
    width: 98.97,
    height: 226.37
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 367.78,
    width: 98.97,
    height: 226.37,
    id: "SVGID_00000146472667952286807260000012510606752196285068_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000146483637836299719340000018162412894227765636_",
    cx: 1630.2845,
    cy: -193.5944,
    r: 87.4495,
    gradientTransform: "matrix(0.4462 0.8949 -0.8949 0.4462 -286.5156 -891.6009)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000146472667952286807260000012510606752196285068_)",
      "fill": "url(#SVGID_00000146483637836299719340000018162412894227765636_)"
    },
    d: " M566.18,594.14c-0.2,0-0.4-0.04-0.59-0.12c-0.76-0.33-1.11-1.21-0.79-1.97l95.97-223.37c0.33-0.76,1.21-1.12,1.97-0.79 c0.76,0.33,1.11,1.21,0.79,1.97l-95.97,223.37C567.32,593.8,566.76,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093166000340237415580000003405281923503190447_",
    cx: 1630.2845,
    cy: -193.5944,
    r: 87.4495,
    gradientTransform: "matrix(0.4462 0.8949 -0.8949 0.4462 -286.5156 -891.6009)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000093166000340237415580000003405281923503190447_)"
    },
    d: " M566.18,594.14c-0.2,0-0.4-0.04-0.59-0.12c-0.76-0.33-1.11-1.21-0.79-1.97l95.97-223.37c0.33-0.76,1.21-1.12,1.97-0.79 c0.76,0.33,1.11,1.21,0.79,1.97l-95.97,223.37C567.32,593.8,566.76,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000009556909446588810720000012841434180617199019_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 328.4,
    width: 142.7,
    height: 265.76
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 328.4,
    width: 142.7,
    height: 265.76,
    id: "SVGID_00000129205612144258196210000004181551548358958215_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000009556909446588810720000012841434180617199019_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000125564251618394233620000009132552604371843478_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 328.4,
    width: 142.7,
    height: 265.76
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 328.4,
    width: 142.7,
    height: 265.76,
    id: "SVGID_00000129205612144258196210000004181551548358958215_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000055666878446739204000000009602499252938319256_",
    cx: 1656.5732,
    cy: -309.5473,
    r: 106.7066,
    gradientTransform: "matrix(0.3706 0.9288 -0.9288 0.3706 -265.3929 -962.6317)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000129205612144258196210000004181551548358958215_)",
      "fill": "url(#SVGID_00000055666878446739204000000009602499252938319256_)"
    },
    d: " M566.19,594.15c-0.24,0-0.48-0.06-0.7-0.18c-0.73-0.39-1.01-1.3-0.62-2.03l139.7-262.76c0.39-0.73,1.3-1.01,2.03-0.62 c0.73,0.39,1.01,1.3,0.62,2.03l-139.7,262.76C567.24,593.86,566.72,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000043455452995513560680000000684201579857669295_",
    cx: 1656.5732,
    cy: -309.5473,
    r: 106.7066,
    gradientTransform: "matrix(0.3706 0.9288 -0.9288 0.3706 -265.3929 -962.6317)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000043455452995513560680000000684201579857669295_)"
    },
    d: " M566.19,594.15c-0.24,0-0.48-0.06-0.7-0.18c-0.73-0.39-1.01-1.3-0.62-2.03l139.7-262.76c0.39-0.73,1.3-1.01,2.03-0.62 c0.73,0.39,1.01,1.3,0.62,2.03l-139.7,262.76C567.24,593.86,566.72,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000104701324423662471630000015258878699633143205_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 386.67,
    width: 134.51,
    height: 207.47
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend33 || (_feBlend33 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 386.67,
    width: 134.51,
    height: 207.47,
    id: "SVGID_00000129915998806928911950000008065311929068966824_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000104701324423662471630000015258878699633143205_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000058567274288544199610000013252903162815453572_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 386.67,
    width: 134.51,
    height: 207.47
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend34 || (_feBlend34 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 386.67,
    width: 134.51,
    height: 207.47,
    id: "SVGID_00000129915998806928911950000008065311929068966824_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000049192912029438847020000013284700468127619206_",
    cx: 1710.6858,
    cy: -387.3352,
    r: 87.4464,
    gradientTransform: "matrix(0.2924 0.9563 -0.9563 0.2924 -238.677 -1032.2639)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000129915998806928911950000008065311929068966824_)",
      "fill": "url(#SVGID_00000049192912029438847020000013284700468127619206_)"
    },
    d: " M566.18,594.14c-0.28,0-0.56-0.08-0.81-0.24c-0.7-0.45-0.9-1.38-0.45-2.07l131.51-204.47c0.45-0.7,1.38-0.9,2.07-0.45 c0.7,0.45,0.9,1.38,0.45,2.07L567.44,593.45C567.16,593.9,566.67,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013907274409998786740000017316853322278636456_",
    cx: 1710.6858,
    cy: -387.3352,
    r: 87.4464,
    gradientTransform: "matrix(0.2924 0.9563 -0.9563 0.2924 -238.677 -1032.2639)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000013907274409998786740000017316853322278636456_)"
    },
    d: " M566.18,594.14c-0.28,0-0.56-0.08-0.81-0.24c-0.7-0.45-0.9-1.38-0.45-2.07l131.51-204.47c0.45-0.7,1.38-0.9,2.07-0.45 c0.7,0.45,0.9,1.38,0.45,2.07L567.44,593.45C567.16,593.9,566.67,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000015340905801677655280000017456658308828570794_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 355.05,
    width: 184.14,
    height: 239.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend35 || (_feBlend35 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 355.05,
    width: 184.14,
    height: 239.1,
    id: "SVGID_00000052784252311445718950000002104451030898791614_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000015340905801677655280000017456658308828570794_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000112608813739533925330000017843807112142625938_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 355.05,
    width: 184.14,
    height: 239.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend36 || (_feBlend36 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 355.05,
    width: 184.14,
    height: 239.1,
    id: "SVGID_00000052784252311445718950000002104451030898791614_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000183957689863151612620000000092128821235062659_",
    cx: 1721.4952,
    cy: -509.0509,
    r: 106.7107,
    gradientTransform: "matrix(0.2122 0.9772 -0.9772 0.2122 -205.9846 -1099.6233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000052784252311445718950000002104451030898791614_)",
      "fill": "url(#SVGID_00000183957689863151612620000000092128821235062659_)"
    },
    d: " M566.19,594.15c-0.32,0-0.64-0.1-0.91-0.31c-0.66-0.5-0.78-1.45-0.28-2.1l181.14-236.1c0.5-0.66,1.44-0.78,2.1-0.28 c0.66,0.5,0.78,1.45,0.28,2.1l-181.14,236.1C567.08,593.95,566.64,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000177471168815577424870000005979193493723843747_",
    cx: 1721.4952,
    cy: -509.0509,
    r: 106.7107,
    gradientTransform: "matrix(0.2122 0.9772 -0.9772 0.2122 -205.9846 -1099.6233)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000177471168815577424870000005979193493723843747_)"
    },
    d: " M566.19,594.15c-0.32,0-0.64-0.1-0.91-0.31c-0.66-0.5-0.78-1.45-0.28-2.1l181.14-236.1c0.5-0.66,1.44-0.78,2.1-0.28 c0.66,0.5,0.78,1.45,0.28,2.1l-181.14,236.1C567.08,593.95,566.64,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000018214586194089151940000000888645495543550397_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 411.18,
    width: 166.44,
    height: 182.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend37 || (_feBlend37 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 411.18,
    width: 166.44,
    height: 182.97,
    id: "SVGID_00000118375193543498320630000017969281189549052572_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000018214586194089151940000000888645495543550397_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000155111425999670188450000016038074917190469771_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 411.18,
    width: 166.44,
    height: 182.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend38 || (_feBlend38 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 411.18,
    width: 166.44,
    height: 182.97,
    id: "SVGID_00000118375193543498320630000017969281189549052572_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000123405731938405845170000003074858074453575313_",
    cx: 1758.4824,
    cy: -590.8229,
    r: 87.4501,
    gradientTransform: "matrix(0.1306 0.9914 -0.9914 0.1306 -167.4952 -1163.5388)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000118375193543498320630000017969281189549052572_)",
      "fill": "url(#SVGID_00000123405731938405845170000003074858074453575313_)"
    },
    d: " M566.18,594.14c-0.36,0-0.72-0.13-1.01-0.39c-0.61-0.56-0.66-1.51-0.1-2.12l163.44-179.97c0.56-0.61,1.51-0.66,2.12-0.1 c0.61,0.56,0.66,1.51,0.1,2.12L567.29,593.65C567,593.98,566.59,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127046393823930690860000016115873492168225166_",
    cx: 1758.4824,
    cy: -590.8229,
    r: 87.4501,
    gradientTransform: "matrix(0.1306 0.9914 -0.9914 0.1306 -167.4952 -1163.5388)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000127046393823930690860000016115873492168225166_)"
    },
    d: " M566.18,594.14c-0.36,0-0.72-0.13-1.01-0.39c-0.61-0.56-0.66-1.51-0.1-2.12l163.44-179.97c0.56-0.61,1.51-0.66,2.12-0.1 c0.61,0.56,0.66,1.51,0.1,2.12L567.29,593.65C567,593.98,566.59,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000166652522507128232460000010323959518805618832_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 388.18,
    width: 220.62,
    height: 205.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend39 || (_feBlend39 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 388.18,
    width: 220.62,
    height: 205.98,
    id: "SVGID_00000083062326563434879050000016470649919014278565_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000166652522507128232460000010323959518805618832_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000136379936482962566200000002765820249457651081_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 388.18,
    width: 220.62,
    height: 205.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend40 || (_feBlend40 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 388.18,
    width: 220.62,
    height: 205.98,
    id: "SVGID_00000083062326563434879050000016470649919014278565_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000101104885191249622940000004718660521346620310_",
    cx: 1751.7341,
    cy: -715.5129,
    r: 106.7121,
    gradientTransform: "matrix(0.0481 0.9988 -0.9988 0.0481 -123.9136 -1224.0505)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000083062326563434879050000016470649919014278565_)",
      "fill": "url(#SVGID_00000101104885191249622940000004718660521346620310_)"
    },
    d: " M566.19,594.15c-0.4,0-0.8-0.16-1.1-0.48c-0.57-0.61-0.53-1.56,0.07-2.12l217.62-202.98c0.61-0.56,1.56-0.53,2.12,0.07 c0.57,0.61,0.53,1.56-0.07,2.12L567.21,593.75C566.92,594.02,566.56,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000067225451026234259080000004222814805015439500_",
    cx: 1751.7341,
    cy: -715.5129,
    r: 106.7121,
    gradientTransform: "matrix(0.0481 0.9988 -0.9988 0.0481 -123.9136 -1224.0505)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000067225451026234259080000004222814805015439500_)"
    },
    d: " M566.19,594.15c-0.4,0-0.8-0.16-1.1-0.48c-0.57-0.61-0.53-1.56,0.07-2.12l217.62-202.98c0.61-0.56,1.56-0.53,2.12,0.07 c0.57,0.61,0.53,1.56-0.07,2.12L567.21,593.75C566.92,594.02,566.56,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000044179453407236683020000005048564559368854663_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 440.61,
    width: 193.9,
    height: 153.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend41 || (_feBlend41 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 440.61,
    width: 193.9,
    height: 153.53,
    id: "SVGID_00000124877817024815143040000013495140866494590882_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000044179453407236683020000005048564559368854663_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000069356995129439878660000013762200063569188226_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 440.61,
    width: 193.9,
    height: 153.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend42 || (_feBlend42 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 440.61,
    width: 193.9,
    height: 153.53,
    id: "SVGID_00000124877817024815143040000013495140866494590882_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016051268957848106960000000494242123861000626_",
    cx: 1771.4559,
    cy: -800.1921,
    r: 87.4461,
    gradientTransform: "matrix(-0.0348 0.9994 -0.9994 -0.0348 -76.4334 -1280.8621)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000124877817024815143040000013495140866494590882_)",
      "fill": "url(#SVGID_00000016051268957848106960000000494242123861000626_)"
    },
    d: " M566.18,594.14c-0.44,0-0.88-0.2-1.18-0.57c-0.51-0.65-0.4-1.59,0.25-2.11l190.9-150.53c0.65-0.51,1.59-0.4,2.11,0.25 c0.51,0.65,0.4,1.59-0.25,2.11l-190.9,150.53C566.84,594.04,566.51,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057847346598194752060000017777655923488449678_",
    cx: 1771.4559,
    cy: -800.1921,
    r: 87.4461,
    gradientTransform: "matrix(-0.0348 0.9994 -0.9994 -0.0348 -76.4334 -1280.8621)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000057847346598194752060000017777655923488449678_)"
    },
    d: " M566.18,594.14c-0.44,0-0.88-0.2-1.18-0.57c-0.51-0.65-0.4-1.59,0.25-2.11l190.9-150.53c0.65-0.51,1.59-0.4,2.11,0.25 c0.51,0.65,0.4,1.59-0.25,2.11l-190.9,150.53C566.84,594.04,566.51,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000144335996890788094900000014334106319994419097_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 426.87,
    width: 251.13,
    height: 167.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend43 || (_feBlend43 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 426.87,
    width: 251.13,
    height: 167.28,
    id: "SVGID_00000077287952208020854730000015550187497210075566_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000144335996890788094900000014334106319994419097_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000107552969311621667630000015172869048781703058_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 426.87,
    width: 251.13,
    height: 167.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend44 || (_feBlend44 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 426.87,
    width: 251.13,
    height: 167.28,
    id: "SVGID_00000077287952208020854730000015550187497210075566_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000136409717731847183680000010726458332639904696_",
    cx: 1747.24,
    cy: -925.416,
    r: 106.7058,
    gradientTransform: "matrix(-0.1174 0.9931 -0.9931 -0.1174 -23.6507 -1333.3164)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000077287952208020854730000015550187497210075566_)",
      "fill": "url(#SVGID_00000136409717731847183680000010726458332639904696_)"
    },
    d: " M566.19,594.15c-0.49,0-0.96-0.24-1.25-0.67c-0.46-0.69-0.27-1.62,0.42-2.08l248.13-164.28c0.69-0.45,1.62-0.27,2.08,0.42 c0.46,0.69,0.27,1.62-0.42,2.08L567.02,593.9C566.76,594.07,566.48,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000094584658140954355480000011263346297795711879_",
    cx: 1747.24,
    cy: -925.416,
    r: 106.7058,
    gradientTransform: "matrix(-0.1174 0.9931 -0.9931 -0.1174 -23.6507 -1333.3164)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000094584658140954355480000011263346297795711879_)"
    },
    d: " M566.19,594.15c-0.49,0-0.96-0.24-1.25-0.67c-0.46-0.69-0.27-1.62,0.42-2.08l248.13-164.28c0.69-0.45,1.62-0.27,2.08,0.42 c0.46,0.69,0.27,1.62-0.42,2.08L567.02,593.9C566.76,594.07,566.48,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000182508837614202848200000003533189812666179969_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 474.18,
    width: 216.12,
    height: 119.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend45 || (_feBlend45 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 474.18,
    width: 216.12,
    height: 119.97,
    id: "SVGID_00000142163662803739029970000014597741648884227240_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000182508837614202848200000003533189812666179969_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000116233308815500554870000013438081673838650283_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 474.18,
    width: 216.12,
    height: 119.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend46 || (_feBlend46 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 474.18,
    width: 216.12,
    height: 119.97,
    id: "SVGID_00000142163662803739029970000014597741648884227240_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000173848516262590655760000015576202220915400087_",
    cx: 1749.4337,
    cy: -1008.2683,
    r: 87.4433,
    gradientTransform: "matrix(-0.1992 0.98 -0.98 -0.1992 33.127 -1381.1328)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000142163662803739029970000014597741648884227240_)",
      "fill": "url(#SVGID_00000173848516262590655760000015576202220915400087_)"
    },
    d: " M566.18,594.14c-0.53,0-1.04-0.28-1.32-0.78c-0.4-0.73-0.13-1.64,0.59-2.04l213.12-116.97c0.72-0.4,1.64-0.13,2.04,0.59 c0.4,0.73,0.13,1.64-0.59,2.04L566.9,593.96C566.68,594.08,566.43,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000042008930245249071590000010989167122590084749_",
    cx: 1749.4337,
    cy: -1008.2683,
    r: 87.4433,
    gradientTransform: "matrix(-0.1992 0.98 -0.98 -0.1992 33.127 -1381.1328)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000042008930245249071590000010989167122590084749_)"
    },
    d: " M566.18,594.14c-0.53,0-1.04-0.28-1.32-0.78c-0.4-0.73-0.13-1.64,0.59-2.04l213.12-116.97c0.72-0.4,1.64-0.13,2.04,0.59 c0.4,0.73,0.13,1.64-0.59,2.04L566.9,593.96C566.68,594.08,566.43,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000154400250127870252630000001488713591809686433_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 470.06,
    width: 274.84,
    height: 124.09
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend47 || (_feBlend47 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 470.06,
    width: 274.84,
    height: 124.09,
    id: "SVGID_00000159459248398952992850000010482646224611161225_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000154400250127870252630000001488713591809686433_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026158828814871176520000001846358310306475933_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 470.06,
    width: 274.84,
    height: 124.09
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend48 || (_feBlend48 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 470.06,
    width: 274.84,
    height: 124.09,
    id: "SVGID_00000159459248398952992850000010482646224611161225_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116227542565270242530000003996555329798183612_",
    cx: 1708.9479,
    cy: -1131.5219,
    r: 106.7065,
    gradientTransform: "matrix(-0.2797 0.9601 -0.9601 -0.2797 93.7262 -1425.1392)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000159459248398952992850000010482646224611161225_)",
      "fill": "url(#SVGID_00000116227542565270242530000003996555329798183612_)"
    },
    d: " M566.19,594.15c-0.57,0-1.12-0.33-1.37-0.89c-0.34-0.76,0-1.64,0.76-1.98l271.84-121.09c0.76-0.34,1.64,0,1.98,0.76 c0.34,0.76,0,1.64-0.76,1.98L566.8,594.02C566.6,594.11,566.39,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000037679110416704981940000003985342325296495269_",
    cx: 1708.9479,
    cy: -1131.5219,
    r: 106.7065,
    gradientTransform: "matrix(-0.2797 0.9601 -0.9601 -0.2797 93.7262 -1425.1392)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000037679110416704981940000003985342325296495269_)"
    },
    d: " M566.19,594.15c-0.57,0-1.12-0.33-1.37-0.89c-0.34-0.76,0-1.64,0.76-1.98l271.84-121.09c0.76-0.34,1.64,0,1.98,0.76 c0.34,0.76,0,1.64-0.76,1.98L566.8,594.02C566.6,594.11,566.39,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000033336354034269349450000014836816171418174891_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 510.94,
    width: 232.5,
    height: 83.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend49 || (_feBlend49 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 510.94,
    width: 232.5,
    height: 83.2,
    id: "SVGID_00000070805952919238452190000002061463930581329794_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000033336354034269349450000014836816171418174891_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000099661775812350959770000011609602532186484125_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 510.94,
    width: 232.5,
    height: 83.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend50 || (_feBlend50 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 510.94,
    width: 232.5,
    height: 83.2,
    id: "SVGID_00000070805952919238452190000002061463930581329794_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000136383274313750477750000013109675690946847360_",
    cx: 1695.0696,
    cy: -1210.0848,
    r: 87.4508,
    gradientTransform: "matrix(-0.3582 0.9336 -0.9336 -0.3582 158.3712 -1463.4258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000070805952919238452190000002061463930581329794_)",
      "fill": "url(#SVGID_00000136383274313750477750000013109675690946847360_)"
    },
    d: " M566.18,594.14c-0.62,0-1.2-0.39-1.42-1c-0.27-0.78,0.14-1.64,0.92-1.91l229.5-80.2c0.78-0.28,1.64,0.14,1.91,0.92 c0.27,0.78-0.14,1.64-0.92,1.91l-229.5,80.2C566.51,594.12,566.35,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000046329919610386167490000015719423934351398020_",
    cx: 1695.0696,
    cy: -1210.0848,
    r: 87.4508,
    gradientTransform: "matrix(-0.3582 0.9336 -0.9336 -0.3582 158.3712 -1463.4258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000046329919610386167490000015719423934351398020_)"
    },
    d: " M566.18,594.14c-0.62,0-1.2-0.39-1.42-1c-0.27-0.78,0.14-1.64,0.92-1.91l229.5-80.2c0.78-0.28,1.64,0.14,1.91,0.92 c0.27,0.78-0.14,1.64-0.92,1.91l-229.5,80.2C566.51,594.12,566.35,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000015330242315737509040000015983666848863480973_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 516.58,
    width: 291.09,
    height: 77.57
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend51 || (_feBlend51 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 516.58,
    width: 291.09,
    height: 77.57,
    id: "SVGID_00000035528912485634142600000002341364422406675629_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000015330242315737509040000015983666848863480973_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000103261999253007784930000008491897503403184788_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 516.58,
    width: 291.09,
    height: 77.57
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend52 || (_feBlend52 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 516.58,
    width: 291.09,
    height: 77.57,
    id: "SVGID_00000035528912485634142600000002341364422406675629_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114780319529395376310000001831266044213467292_",
    cx: 1636.7919,
    cy: -1328.1925,
    r: 106.7042,
    gradientTransform: "matrix(-0.4343 0.9008 -0.9008 -0.4343 224.6572 -1495.8894)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000035528912485634142600000002341364422406675629_)",
      "fill": "url(#SVGID_00000114780319529395376310000001831266044213467292_)"
    },
    d: " M566.19,594.15c-0.67,0-1.28-0.45-1.45-1.12c-0.21-0.8,0.27-1.62,1.08-1.83l288.09-74.57c0.81-0.2,1.62,0.28,1.83,1.08 c0.21,0.8-0.27,1.62-1.08,1.83l-288.09,74.57C566.44,594.14,566.31,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000133531285606249413880000004738071037911765650_",
    cx: 1636.7919,
    cy: -1328.1925,
    r: 106.7042,
    gradientTransform: "matrix(-0.4343 0.9008 -0.9008 -0.4343 224.6572 -1495.8894)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000133531285606249413880000004738071037911765650_)"
    },
    d: " M566.19,594.15c-0.67,0-1.28-0.45-1.45-1.12c-0.21-0.8,0.27-1.62,1.08-1.83l288.09-74.57c0.81-0.2,1.62,0.28,1.83,1.08 c0.21,0.8-0.27,1.62-1.08,1.83l-288.09,74.57C566.44,594.14,566.31,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000114780135967395891380000015702877955123508650_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 549.92,
    width: 242.59,
    height: 44.23
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend53 || (_feBlend53 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 549.92,
    width: 242.59,
    height: 44.23,
    id: "SVGID_00000122688136446916445030000016779146097664790178_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000114780135967395891380000015702877955123508650_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000125562726425599232660000003913809279069308558_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 549.92,
    width: 242.59,
    height: 44.23
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend54 || (_feBlend54 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 549.92,
    width: 242.59,
    height: 44.23,
    id: "SVGID_00000122688136446916445030000016779146097664790178_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047049084903872344150000007793170676470764218_",
    cx: 1606.955,
    cy: -1399.5389,
    r: 87.4523,
    gradientTransform: "matrix(-0.5073 0.8617 -0.8617 -0.5073 295.2017 -1522.6707)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000122688136446916445030000016779146097664790178_)",
      "fill": "url(#SVGID_00000047049084903872344150000007793170676470764218_)"
    },
    d: " M566.18,594.14c-0.72,0-1.35-0.52-1.48-1.25c-0.14-0.82,0.41-1.59,1.22-1.73l239.59-41.23c0.82-0.14,1.59,0.41,1.73,1.22 c0.14,0.82-0.41,1.59-1.22,1.73l-239.59,41.23C566.35,594.14,566.27,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000120519618446269980260000004645046514282217653_",
    cx: 1606.955,
    cy: -1399.5389,
    r: 87.4523,
    gradientTransform: "matrix(-0.5073 0.8617 -0.8617 -0.5073 295.2017 -1522.6707)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000120519618446269980260000004645046514282217653_)"
    },
    d: " M566.18,594.14c-0.72,0-1.35-0.52-1.48-1.25c-0.14-0.82,0.41-1.59,1.22-1.73l239.59-41.23c0.82-0.14,1.59,0.41,1.73,1.22 c0.14,0.82-0.41,1.59-1.22,1.73l-239.59,41.23C566.35,594.14,566.27,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000087397654824745854890000004766490256421158841_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 565.14,
    width: 299.45,
    height: 29.01
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend55 || (_feBlend55 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 565.14,
    width: 299.45,
    height: 29.01,
    id: "SVGID_00000049932982771863149250000007618837938666315648_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000087397654824745854890000004766490256421158841_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000169539781327984439590000010923495682364895381_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 565.14,
    width: 299.45,
    height: 29.01
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend56 || (_feBlend56 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 565.14,
    width: 299.45,
    height: 29.01,
    id: "SVGID_00000049932982771863149250000007618837938666315648_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000056412336977359414100000009265896337358711688_",
    cx: 1533.2311,
    cy: -1509.2003,
    r: 106.7086,
    gradientTransform: "matrix(-0.5769 0.8168 -0.8168 -0.5769 366.2187 -1543.3541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000049932982771863149250000007618837938666315648_)",
      "fill": "url(#SVGID_00000056412336977359414100000009265896337358711688_)"
    },
    d: " M566.19,594.15c-0.77,0-1.42-0.59-1.49-1.37c-0.07-0.83,0.54-1.55,1.36-1.62l296.45-26.01c0.82-0.07,1.55,0.54,1.62,1.36 c0.07,0.83-0.54,1.55-1.36,1.62l-296.45,26.01C566.28,594.15,566.23,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116926526791950738400000000364723556433818023_",
    cx: 1533.2311,
    cy: -1509.2003,
    r: 106.7086,
    gradientTransform: "matrix(-0.5769 0.8168 -0.8168 -0.5769 366.2187 -1543.3541)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000116926526791950738400000000364723556433818023_)"
    },
    d: " M566.19,594.15c-0.77,0-1.42-0.59-1.49-1.37c-0.07-0.83,0.54-1.55,1.36-1.62l296.45-26.01c0.82-0.07,1.55,0.54,1.62,1.36 c0.07,0.83-0.54,1.55-1.36,1.62l-296.45,26.01C566.28,594.15,566.23,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000170997524954753595570000010027425999905962895_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 590.01,
    width: 246.11,
    height: 4.13
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend57 || (_feBlend57 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 590.01,
    width: 246.11,
    height: 4.13,
    id: "SVGID_00000144332128399535616810000015388988418808278700_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000170997524954753595570000010027425999905962895_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000081622020266655549990000017592038567094792361_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 590.01,
    width: 246.11,
    height: 4.13
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend58 || (_feBlend58 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 590.01,
    width: 246.11,
    height: 4.13,
    id: "SVGID_00000144332128399535616810000015388988418808278700_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096755305107252627930000013262435218513606588_",
    cx: 1488.4761,
    cy: -1573.0248,
    r: 87.447,
    gradientTransform: "matrix(-0.6426 0.7662 -0.7662 -0.6426 438.9785 -1559.218)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000144332128399535616810000015388988418808278700_)",
      "fill": "url(#SVGID_00000096755305107252627930000013262435218513606588_)"
    },
    d: " M566.18,594.14c-0.83,0-1.5-0.67-1.5-1.49c0-0.83,0.67-1.5,1.49-1.51l243.11-1.13c0,0,0,0,0,0c0.83,0,1.5,0.67,1.5,1.49 c0,0.83-0.67,1.5-1.49,1.51L566.18,594.14C566.19,594.14,566.18,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008868994442426341400000002534845605311296690_",
    cx: 1488.4761,
    cy: -1573.0248,
    r: 87.447,
    gradientTransform: "matrix(-0.6426 0.7662 -0.7662 -0.6426 438.9785 -1559.218)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000008868994442426341400000002534845605311296690_)"
    },
    d: " M566.18,594.14c-0.83,0-1.5-0.67-1.5-1.49c0-0.83,0.67-1.5,1.49-1.51l243.11-1.13c0,0,0,0,0,0c0.83,0,1.5,0.67,1.5,1.49 c0,0.83-0.67,1.5-1.49,1.51L566.18,594.14C566.19,594.14,566.18,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000070817392265523215380000004568101761233191080_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 299.68,
    height: 26.26
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend59 || (_feBlend59 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 299.68,
    height: 26.26,
    id: "SVGID_00000166646551752759050190000016042012493406013836_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000070817392265523215380000004568101761233191080_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000019673935822741347660000001564758008643047347_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 299.68,
    height: 26.26
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend60 || (_feBlend60 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask30 || (_mask30 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 299.68,
    height: 26.26,
    id: "SVGID_00000166646551752759050190000016042012493406013836_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000069376059831237613420000010187246573182658200_",
    cx: 1401.2139,
    cy: -1671.9401,
    r: 106.7084,
    gradientTransform: "matrix(-0.7038 0.7104 -0.7104 -0.7038 512.9537 -1567.8525)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000166646551752759050190000016042012493406013836_)",
      "fill": "url(#SVGID_00000069376059831237613420000010187246573182658200_)"
    },
    d: " M862.87,617.41c-0.04,0-0.08,0-0.12,0l-296.68-23.26c-0.83-0.06-1.44-0.79-1.38-1.61c0.06-0.83,0.79-1.46,1.61-1.38 l296.68,23.26c0.83,0.06,1.44,0.79,1.38,1.61C864.3,616.82,863.64,617.41,862.87,617.41z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000082332221388963283260000006611658202955193493_",
    cx: 1401.2139,
    cy: -1671.9401,
    r: 106.7084,
    gradientTransform: "matrix(-0.7038 0.7104 -0.7104 -0.7038 512.9537 -1567.8525)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000082332221388963283260000006611658202955193493_)"
    },
    d: " M862.87,617.41c-0.04,0-0.08,0-0.12,0l-296.68-23.26c-0.83-0.06-1.44-0.79-1.38-1.61c0.06-0.83,0.79-1.46,1.61-1.38l296.68,23.26 c0.83,0.06,1.44,0.79,1.38,1.61C864.3,616.82,863.64,617.41,862.87,617.41z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000136379249717372070880000004628993864751234983_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 242.96,
    height: 42
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend61 || (_feBlend61 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 242.96,
    height: 42,
    id: "SVGID_00000031180744653264221870000005307254776112383165_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000136379249717372070880000004628993864751234983_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000012447128367553163240000011134872624721419929_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 242.96,
    height: 42
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend62 || (_feBlend62 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask31 || (_mask31 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 242.96,
    height: 42,
    id: "SVGID_00000031180744653264221870000005307254776112383165_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000162333089993421547050000018236591731051662466_",
    cx: 1343.0919,
    cy: -1723.606,
    r: 87.4467,
    gradientTransform: "matrix(-0.7602 0.6497 -0.6497 -0.7602 587.3534 -1570.7498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000031180744653264221870000005307254776112383165_)",
      "fill": "url(#SVGID_00000162333089993421547050000018236591731051662466_)"
    },
    d: " M806.14,633.14c-0.08,0-0.16-0.01-0.24-0.02l-239.96-39c-0.82-0.13-1.37-0.9-1.24-1.72c0.13-0.82,0.9-1.38,1.72-1.24l239.96,39 c0.82,0.13,1.37,0.9,1.24,1.72C807.5,632.62,806.87,633.14,806.14,633.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000009575478948333036490000004025153342690318739_",
    cx: 1343.0919,
    cy: -1723.606,
    r: 87.4467,
    gradientTransform: "matrix(-0.7602 0.6497 -0.6497 -0.7602 587.3534 -1570.7498)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000009575478948333036490000004025153342690318739_)"
    },
    d: " M806.14,633.14c-0.08,0-0.16-0.01-0.24-0.02l-239.96-39c-0.82-0.13-1.37-0.9-1.24-1.72c0.13-0.82,0.9-1.38,1.72-1.24l239.96,39 c0.82,0.13,1.37,0.9,1.24,1.72C807.5,632.62,806.87,633.14,806.14,633.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000152954372484587191260000010406689837805777543_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 291.77,
    height: 74.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend63 || (_feBlend63 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 291.77,
    height: 74.9,
    id: "SVGID_00000012438251431786427620000004069941432151275399_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000152954372484587191260000010406689837805777543_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000123419036911375788590000013504855281440775586_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 291.77,
    height: 74.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend64 || (_feBlend64 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask32 || (_mask32 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 291.77,
    height: 74.9,
    id: "SVGID_00000012438251431786427620000004069941432151275399_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000104690114892707868880000007404601274948498308_",
    cx: 1244.3524,
    cy: -1810.6929,
    r: 106.7073,
    gradientTransform: "matrix(-0.8114 0.5845 -0.5845 -0.8114 661.8922 -1567.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000012438251431786427620000004069941432151275399_)",
      "fill": "url(#SVGID_00000104690114892707868880000007404601274948498308_)"
    },
    d: " M854.96,666.05c-0.12,0-0.24-0.01-0.36-0.04l-288.77-71.89c-0.8-0.2-1.29-1.01-1.09-1.82c0.2-0.8,1.01-1.29,1.82-1.09 l288.77,71.89c0.8,0.2,1.29,1.01,1.09,1.82C856.25,665.59,855.63,666.05,854.96,666.05z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000065037392498036541970000012901064717700816015_",
    cx: 1244.3524,
    cy: -1810.6929,
    r: 106.7073,
    gradientTransform: "matrix(-0.8114 0.5845 -0.5845 -0.8114 661.8922 -1567.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000065037392498036541970000012901064717700816015_)"
    },
    d: " M854.96,666.05c-0.12,0-0.24-0.01-0.36-0.04l-288.77-71.89c-0.8-0.2-1.29-1.01-1.09-1.82c0.2-0.8,1.01-1.29,1.82-1.09 l288.77,71.89c0.8,0.2,1.29,1.01,1.09,1.82C856.25,665.59,855.63,666.05,854.96,666.05z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000046303005795749178790000013684532061831835293_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 233.24,
    height: 81.06
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend65 || (_feBlend65 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 233.24,
    height: 81.06,
    id: "SVGID_00000114044348196601627040000002167344642108255140_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000046303005795749178790000013684532061831835293_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000121965458767028429590000003355371108074821783_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 233.24,
    height: 81.06
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend66 || (_feBlend66 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask33 || (_mask33 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 233.24,
    height: 81.06,
    id: "SVGID_00000114044348196601627040000002167344642108255140_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000046326686174126580000000005579012396614430372_",
    cx: 1175.5773,
    cy: -1848.9052,
    r: 87.4478,
    gradientTransform: "matrix(-0.857 0.5153 -0.5153 -0.857 736.0287 -1558.6132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000114044348196601627040000002167344642108255140_)",
      "fill": "url(#SVGID_00000046326686174126580000000005579012396614430372_)"
    },
    d: " M796.42,672.2c-0.16,0-0.32-0.03-0.48-0.08L565.7,594.06c-0.79-0.27-1.21-1.12-0.94-1.9c0.27-0.78,1.12-1.21,1.9-0.94 l230.24,78.06c0.79,0.27,1.21,1.12,0.94,1.9C797.63,671.81,797.04,672.2,796.42,672.2z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004517246986667761040000013049915438040295871_",
    cx: 1175.5773,
    cy: -1848.9052,
    r: 87.4478,
    gradientTransform: "matrix(-0.857 0.5153 -0.5153 -0.857 736.0287 -1558.6132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000004517246986667761040000013049915438040295871_)"
    },
    d: " M796.42,672.2c-0.16,0-0.32-0.03-0.48-0.08L565.7,594.06c-0.79-0.27-1.21-1.12-0.94-1.9c0.27-0.78,1.12-1.21,1.9-0.94 l230.24,78.06c0.79,0.27,1.21,1.12,0.94,1.9C797.63,671.81,797.04,672.2,796.42,672.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000024685091035652233080000006651144287383238304_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 275.95,
    height: 121.56
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend67 || (_feBlend67 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 275.95,
    height: 121.56,
    id: "SVGID_00000142887003134709659250000008072945373073370004_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000024685091035652233080000006651144287383238304_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000044875143910200724820000016272017720894566549_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 275.95,
    height: 121.56
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend68 || (_feBlend68 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask34 || (_mask34 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 275.95,
    height: 121.56,
    id: "SVGID_00000142887003134709659250000008072945373073370004_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000082343092914850929180000003121086548629940893_",
    cx: 1066.7462,
    cy: -1921.0371,
    r: 106.7091,
    gradientTransform: "matrix(-0.8967 0.4426 -0.4426 -0.8967 808.9641 -1542.8032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000142887003134709659250000008072945373073370004_)",
      "fill": "url(#SVGID_00000082343092914850929180000003121086548629940893_)"
    },
    d: " M839.14,712.71c-0.2,0-0.4-0.04-0.6-0.12L565.59,594.03c-0.76-0.33-1.11-1.21-0.78-1.97c0.33-0.76,1.21-1.11,1.97-0.78 l272.95,118.56c0.76,0.33,1.11,1.21,0.78,1.97C840.27,712.37,839.72,712.71,839.14,712.71z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000053507847935401035970000011638650485482880403_",
    cx: 1066.7462,
    cy: -1921.0371,
    r: 106.7091,
    gradientTransform: "matrix(-0.8967 0.4426 -0.4426 -0.8967 808.9641 -1542.8032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000053507847935401035970000011638650485482880403_)"
    },
    d: " M839.14,712.71c-0.2,0-0.4-0.04-0.6-0.12L565.59,594.03c-0.76-0.33-1.11-1.21-0.78-1.97c0.33-0.76,1.21-1.11,1.97-0.78 l272.95,118.56c0.76,0.33,1.11,1.21,0.78,1.97C840.27,712.37,839.72,712.71,839.14,712.71z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000121260771052401723700000012393290957091930296_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 217.2,
    height: 117.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend69 || (_feBlend69 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 217.2,
    height: 117.98,
    id: "SVGID_00000149365257246338330590000012247261800424030377_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000121260771052401723700000012393290957091930296_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000102512167779125715080000012672878610540455869_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 217.2,
    height: 117.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend70 || (_feBlend70 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask35 || (_mask35 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 217.2,
    height: 117.98,
    id: "SVGID_00000149365257246338330590000012247261800424030377_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000018944823771850204180000000012258930898106301_",
    cx: 988.5425,
    cy: -1944.0863,
    r: 87.4432,
    gradientTransform: "matrix(-0.9303 0.3669 -0.3669 -0.9303 879.6374 -1521.1455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000149365257246338330590000012247261800424030377_)",
      "fill": "url(#SVGID_00000018944823771850204180000000012258930898106301_)"
    },
    d: " M780.38,709.12c-0.24,0-0.48-0.06-0.71-0.18l-214.2-114.98c-0.73-0.39-1-1.3-0.61-2.03c0.39-0.73,1.3-1,2.03-0.61l214.2,114.98 c0.73,0.39,1,1.3,0.61,2.03C781.43,708.84,780.91,709.12,780.38,709.12z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016069903893684746750000015622066818780626853_",
    cx: 988.5425,
    cy: -1944.0863,
    r: 87.4432,
    gradientTransform: "matrix(-0.9303 0.3669 -0.3669 -0.9303 879.6374 -1521.1455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000016069903893684746750000015622066818780626853_)"
    },
    d: " M780.38,709.12c-0.24,0-0.48-0.06-0.71-0.18l-214.2-114.98c-0.73-0.39-1-1.3-0.61-2.03c0.39-0.73,1.3-1,2.03-0.61l214.2,114.98 c0.73,0.39,1,1.3,0.61,2.03C781.43,708.84,780.91,709.12,780.38,709.12z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000181789608413936154700000002960828628603024564_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 252.65,
    height: 164.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend71 || (_feBlend71 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 252.65,
    height: 164.97,
    id: "SVGID_00000042694887228172437590000011253284468432524181_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000181789608413936154700000002960828628603024564_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000150801690944703087930000012255529597390857880_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 252.65,
    height: 164.97
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend72 || (_feBlend72 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask36 || (_mask36 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 252.65,
    height: 164.97,
    id: "SVGID_00000042694887228172437590000011253284468432524181_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000123402113700417389830000008148555829427938707_",
    cx: 872.5766,
    cy: -2001.0316,
    r: 106.7022,
    gradientTransform: "matrix(-0.9575 0.2886 -0.2886 -0.9575 949.0058 -1494.1736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000042694887228172437590000011253284468432524181_)",
      "fill": "url(#SVGID_00000123402113700417389830000008148555829427938707_)"
    },
    d: " M815.83,756.13c-0.28,0-0.56-0.08-0.82-0.24L565.37,593.91c-0.7-0.45-0.89-1.38-0.44-2.08c0.45-0.69,1.38-0.89,2.08-0.44 l249.64,161.97c0.7,0.45,0.89,1.38,0.44,2.08C816.8,755.88,816.32,756.13,815.83,756.13z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000035508209769580207350000004861146502216177561_",
    cx: 872.5766,
    cy: -2001.0316,
    r: 106.7022,
    gradientTransform: "matrix(-0.9575 0.2886 -0.2886 -0.9575 949.0058 -1494.1736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000035508209769580207350000004861146502216177561_)"
    },
    d: " M815.83,756.13c-0.28,0-0.56-0.08-0.82-0.24L565.37,593.91c-0.7-0.45-0.89-1.38-0.44-2.08c0.45-0.69,1.38-0.89,2.08-0.44 l249.64,161.97c0.7,0.45,0.89,1.38,0.44,2.08C816.8,755.88,816.32,756.13,815.83,756.13z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000078739301377837075770000014520312666849675695_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 195.29,
    height: 151.75
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend73 || (_feBlend73 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 195.29,
    height: 151.75,
    id: "SVGID_00000114766594627735852290000009586449178512465039_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000078739301377837075770000014520312666849675695_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000031191136695797121770000007606066105062284966_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 195.29,
    height: 151.75
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend74 || (_feBlend74 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask37 || (_mask37 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 195.29,
    height: 151.75,
    id: "SVGID_00000114766594627735852290000009586449178512465039_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109710383788916525510000004294299236586258593_",
    cx: 789.4561,
    cy: -2008.0455,
    r: 87.4439,
    gradientTransform: "matrix(-0.9781 0.2083 -0.2083 -0.9781 1016.2179 -1461.4952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000114766594627735852290000009586449178512465039_)",
      "fill": "url(#SVGID_00000109710383788916525510000004294299236586258593_)"
    },
    d: " M758.47,742.89c-0.32,0-0.64-0.1-0.92-0.31L565.26,593.83c-0.66-0.51-0.78-1.45-0.27-2.1c0.51-0.66,1.45-0.77,2.1-0.27 l192.29,148.75c0.66,0.51,0.78,1.45,0.27,2.1C759.36,742.69,758.92,742.89,758.47,742.89z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000145755698122249421560000007803487713899479209_",
    cx: 789.4561,
    cy: -2008.0455,
    r: 87.4439,
    gradientTransform: "matrix(-0.9781 0.2083 -0.2083 -0.9781 1016.2179 -1461.4952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000145755698122249421560000007803487713899479209_)"
    },
    d: " M758.47,742.89c-0.32,0-0.64-0.1-0.92-0.31L565.26,593.83c-0.66-0.51-0.78-1.45-0.27-2.1c0.51-0.66,1.45-0.77,2.1-0.27 l192.29,148.75c0.66,0.51,0.78,1.45,0.27,2.1C759.36,742.69,758.92,742.89,758.47,742.89z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000124879010001950565060000017840762012475785384_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 222.5,
    height: 203.95
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend75 || (_feBlend75 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 222.5,
    height: 203.95,
    id: "SVGID_00000123432235679327098920000004502783224285446581_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000124879010001950565060000017840762012475785384_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000170250746985724684420000006606080999553988284_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 222.5,
    height: 203.95
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend76 || (_feBlend76 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask38 || (_mask38 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 222.5,
    height: 203.95,
    id: "SVGID_00000123432235679327098920000004502783224285446581_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000172416339391596891690000004344083898960345984_",
    cx: 669.5823,
    cy: -2047.4578,
    r: 106.7133,
    gradientTransform: "matrix(-0.9919 0.1266 -0.1266 -0.9919 1080.8877 -1422.5165)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000123432235679327098920000004502783224285446581_)",
      "fill": "url(#SVGID_00000172416339391596891690000004344083898960345984_)"
    },
    d: " M785.69,795.1c-0.36,0-0.72-0.13-1.01-0.39l-219.5-200.95c-0.61-0.56-0.65-1.51-0.09-2.12c0.56-0.61,1.51-0.65,2.12-0.09 l219.5,200.95c0.61,0.56,0.65,1.51,0.09,2.12C786.5,794.93,786.09,795.1,785.69,795.1z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000056386478780886650010000006195985543299838605_",
    cx: 669.5823,
    cy: -2047.4578,
    r: 106.7133,
    gradientTransform: "matrix(-0.9919 0.1266 -0.1266 -0.9919 1080.8877 -1422.5165)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000056386478780886650010000006195985543299838605_)"
    },
    d: " M785.69,795.1c-0.36,0-0.72-0.13-1.01-0.39l-219.5-200.95c-0.61-0.56-0.65-1.51-0.09-2.12c0.56-0.61,1.51-0.65,2.12-0.09 l219.5,200.95c0.61,0.56,0.65,1.51,0.09,2.12C786.5,794.93,786.09,795.1,785.69,795.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000008132833111273290630000012411334110200592549_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 168.11,
    height: 181.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend77 || (_feBlend77 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 168.11,
    height: 181.44,
    id: "SVGID_00000031889385713530475740000008811152998246298504_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000008132833111273290630000012411334110200592549_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000144331154768634660670000004846102454533310337_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 168.11,
    height: 181.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend78 || (_feBlend78 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask39 || (_mask39 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 168.11,
    height: 181.44,
    id: "SVGID_00000031889385713530475740000008811152998246298504_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002360895140556327450000001139486265302253985_",
    cx: 582.4606,
    cy: -2036.9061,
    r: 87.4496,
    gradientTransform: "matrix(-0.999 0.0441 -0.0441 -0.999 1140.787 -1378.6927)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000031889385713530475740000008811152998246298504_)",
      "fill": "url(#SVGID_00000002360895140556327450000001139486265302253985_)"
    },
    d: " M731.29,772.58c-0.4,0-0.81-0.16-1.1-0.48L565.08,593.66c-0.56-0.61-0.53-1.56,0.08-2.12c0.61-0.56,1.56-0.53,2.12,0.08 l165.11,178.44c0.56,0.61,0.53,1.56-0.08,2.12C732.02,772.45,731.66,772.58,731.29,772.58z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000029761349777038234550000006972536937885312445_",
    cx: 582.4606,
    cy: -2036.9061,
    r: 87.4496,
    gradientTransform: "matrix(-0.999 0.0441 -0.0441 -0.999 1140.787 -1378.6927)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000029761349777038234550000006972536937885312445_)"
    },
    d: " M731.29,772.58c-0.4,0-0.81-0.16-1.1-0.48L565.08,593.66c-0.56-0.61-0.53-1.56,0.08-2.12c0.61-0.56,1.56-0.53,2.12,0.08 l165.11,178.44c0.56,0.61,0.53,1.56-0.08,2.12C732.02,772.45,731.66,772.58,731.29,772.58z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000134971529221022472930000009722316194068677553_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 186.33,
    height: 237.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend79 || (_feBlend79 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 186.33,
    height: 237.41,
    id: "SVGID_00000016046008464640692260000009638752087671225731_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000134971529221022472930000009722316194068677553_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000103227394261870259270000005192379633575417753_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 186.33,
    height: 237.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend80 || (_feBlend80 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask40 || (_mask40 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 186.33,
    height: 237.41,
    id: "SVGID_00000016046008464640692260000009638752087671225731_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078016865794445799590000017912739672583103674_",
    cx: 460.5221,
    cy: -2059.8145,
    r: 106.7131,
    gradientTransform: "matrix(-0.9992 -0.0388 0.0388 -0.9992 1197.9286 -1330.4406)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000016046008464640692260000009638752087671225731_)",
      "fill": "url(#SVGID_00000078016865794445799590000017912739672583103674_)"
    },
    d: " M749.52,828.56c-0.45,0-0.89-0.2-1.18-0.58L565.01,593.58c-0.51-0.65-0.39-1.59,0.26-2.11c0.65-0.51,1.59-0.4,2.11,0.26 L750.7,826.14c0.51,0.65,0.39,1.59-0.26,2.11C750.17,828.46,749.84,828.56,749.52,828.56z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000083803951771615733290000002367585410559704511_",
    cx: 460.5221,
    cy: -2059.8145,
    r: 106.7131,
    gradientTransform: "matrix(-0.9992 -0.0388 0.0388 -0.9992 1197.9286 -1330.4406)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000083803951771615733290000002367585410559704511_)"
    },
    d: " M749.52,828.56c-0.45,0-0.89-0.2-1.18-0.58L565.01,593.58c-0.51-0.65-0.39-1.59,0.26-2.11c0.65-0.51,1.59-0.4,2.11,0.26 L750.7,826.14c0.51,0.65,0.39,1.59-0.26,2.11C750.17,828.46,749.84,828.56,749.52,828.56z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000152227424327964793660000008886517178203101353_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 136.4,
    height: 206.24
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend81 || (_feBlend81 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 136.4,
    height: 206.24,
    id: "SVGID_00000052787383426180232160000001107646754228891297_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000152227424327964793660000008886517178203101353_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000071533743476370488070000006651627298064661404_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 136.4,
    height: 206.24
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend82 || (_feBlend82 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask41 || (_mask41 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 136.4,
    height: 206.24,
    id: "SVGID_00000052787383426180232160000001107646754228891297_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013162437008184551370000013434766825815593638_",
    cx: 373.284,
    cy: -2032.4852,
    r: 87.4475,
    gradientTransform: "matrix(-0.9926 -0.1214 0.1214 -0.9926 1250.1483 -1277.8665)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000052787383426180232160000001107646754228891297_)",
      "fill": "url(#SVGID_00000013162437008184551370000013434766825815593638_)"
    },
    d: " M699.58,797.38c-0.49,0-0.97-0.24-1.25-0.68l-133.4-203.24c-0.46-0.69-0.26-1.62,0.43-2.08c0.69-0.46,1.62-0.26,2.08,0.43 l133.4,203.24c0.46,0.69,0.26,1.62-0.43,2.08C700.15,797.3,699.87,797.38,699.58,797.38z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000145032744260667110230000011297393062032032702_",
    cx: 373.284,
    cy: -2032.4852,
    r: 87.4475,
    gradientTransform: "matrix(-0.9926 -0.1214 0.1214 -0.9926 1250.1483 -1277.8665)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000145032744260667110230000011297393062032032702_)"
    },
    d: " M699.58,797.38c-0.49,0-0.97-0.24-1.25-0.68l-133.4-203.24c-0.46-0.69-0.26-1.62,0.43-2.08c0.69-0.46,1.62-0.26,2.08,0.43 l133.4,203.24c0.46,0.69,0.26,1.62-0.43,2.08C700.15,797.3,699.87,797.38,699.58,797.38z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000129911156582935075700000009630559117870853289_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 145.14,
    height: 264.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend83 || (_feBlend83 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 145.14,
    height: 264.45,
    id: "SVGID_00000102506339235457116940000009008730215985039765_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000129911156582935075700000009630559117870853289_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000007411124513559952450000003144761265958980014_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 145.14,
    height: 264.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend84 || (_feBlend84 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask42 || (_mask42 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 145.14,
    height: 264.45,
    id: "SVGID_00000102506339235457116940000009008730215985039765_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000183224962054785097740000007768548882036800176_",
    cx: 251.3288,
    cy: -2037.537,
    r: 106.7031,
    gradientTransform: "matrix(-0.9792 -0.2031 0.2031 -0.9792 1297.1823 -1220.7345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000102506339235457116940000009008730215985039765_)",
      "fill": "url(#SVGID_00000183224962054785097740000007768548882036800176_)"
    },
    d: " M708.33,855.6c-0.53,0-1.05-0.28-1.32-0.78L564.87,593.37c-0.4-0.73-0.13-1.64,0.6-2.03c0.73-0.4,1.64-0.13,2.03,0.6 l142.14,261.45c0.4,0.73,0.13,1.64-0.6,2.03C708.82,855.54,708.57,855.6,708.33,855.6z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000026141224814673100990000012362825013145415580_",
    cx: 251.3288,
    cy: -2037.537,
    r: 106.7031,
    gradientTransform: "matrix(-0.9792 -0.2031 0.2031 -0.9792 1297.1823 -1220.7345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000026141224814673100990000012362825013145415580_)"
    },
    d: " M708.33,855.6c-0.53,0-1.05-0.28-1.32-0.78L564.87,593.37c-0.4-0.73-0.13-1.64,0.6-2.03c0.73-0.4,1.64-0.13,2.03,0.6 l142.14,261.45c0.4,0.73,0.13,1.64-0.6,2.03C708.82,855.54,708.57,855.6,708.33,855.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000182495693539156012800000007957257820646158761_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 101.04,
    height: 225.47
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend85 || (_feBlend85 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 101.04,
    height: 225.47,
    id: "SVGID_00000113335444561540792400000001568925880408777863_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000182495693539156012800000007957257820646158761_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000083052344394787942800000000460861454369181111_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 101.04,
    height: 225.47
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend86 || (_feBlend86 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask43 || (_mask43 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 101.04,
    height: 225.47,
    id: "SVGID_00000113335444561540792400000001568925880408777863_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000094611127346960951870000004085285421090709143_",
    cx: 167.2873,
    cy: -1992.9769,
    r: 87.4444,
    gradientTransform: "matrix(-0.959 -0.2835 0.2835 -0.959 1340.6376 -1159.9631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000113335444561540792400000001568925880408777863_)",
      "fill": "url(#SVGID_00000094611127346960951870000004085285421090709143_)"
    },
    d: " M664.22,816.61c-0.58,0-1.13-0.33-1.37-0.9l-98.04-222.47c-0.33-0.76,0.01-1.64,0.77-1.98c0.76-0.33,1.64,0.01,1.98,0.77 l98.04,222.47c0.33,0.76-0.01,1.64-0.77,1.98C664.63,816.57,664.42,816.61,664.22,816.61z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000073680217877510349910000010342037783662228867_",
    cx: 167.2873,
    cy: -1992.9769,
    r: 87.4444,
    gradientTransform: "matrix(-0.959 -0.2835 0.2835 -0.959 1340.6376 -1159.9631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000073680217877510349910000010342037783662228867_)"
    },
    d: " M664.22,816.61c-0.58,0-1.13-0.33-1.37-0.9l-98.04-222.47c-0.33-0.76,0.01-1.64,0.77-1.98c0.76-0.33,1.64,0.01,1.98,0.77 l98.04,222.47c0.33,0.76-0.01,1.64-0.77,1.98C664.63,816.57,664.42,816.61,664.22,816.61z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000041256160798073696380000009436545585231998115_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 100.05,
    height: 284.32
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend87 || (_feBlend87 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 100.05,
    height: 284.32,
    id: "SVGID_00000084529709663436056550000004389146400707249798_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000041256160798073696380000009436545585231998115_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000114779221279736918520000003709148886179294370_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 100.05,
    height: 284.32
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend88 || (_feBlend88 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask44 || (_mask44 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 100.05,
    height: 284.32,
    id: "SVGID_00000084529709663436056550000004389146400707249798_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000121266543380796585750000008215371604272098961_",
    cx: 50.3371,
    cy: -1981.1591,
    r: 106.7094,
    gradientTransform: "matrix(-0.9322 -0.3619 0.3619 -0.9322 1378.6188 -1095.3079)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000084529709663436056550000004389146400707249798_)",
      "fill": "url(#SVGID_00000121266543380796585750000008215371604272098961_)"
    },
    d: " M663.24,875.47c-0.62,0-1.2-0.39-1.42-1.01l-97.05-281.32c-0.27-0.78,0.15-1.64,0.93-1.91c0.78-0.27,1.64,0.15,1.91,0.93 l97.05,281.32c0.27,0.78-0.15,1.64-0.93,1.91C663.56,875.44,663.4,875.47,663.24,875.47z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000043435621288340763010000001718800842798683530_",
    cx: 50.3371,
    cy: -1981.1591,
    r: 106.7094,
    gradientTransform: "matrix(-0.9322 -0.3619 0.3619 -0.9322 1378.6188 -1095.3079)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000043435621288340763010000001718800842798683530_)"
    },
    d: " M663.24,875.47c-0.62,0-1.2-0.39-1.42-1.01l-97.05-281.32c-0.27-0.78,0.15-1.64,0.93-1.91c0.78-0.27,1.64,0.15,1.91,0.93 l97.05,281.32c0.27,0.78-0.15,1.64-0.93,1.91C663.56,875.44,663.4,875.47,663.24,875.47z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088126994987121663030000005580204068276271795_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 62.98,
    height: 238.59
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend89 || (_feBlend89 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 62.98,
    height: 238.59,
    id: "SVGID_00000008137047919202906030000005362521192746809763_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000088126994987121663030000005580204068276271795_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000067957436278521741940000000892897450873247414_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 62.98,
    height: 238.59
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend90 || (_feBlend90 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask45 || (_mask45 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 62.98,
    height: 238.59,
    id: "SVGID_00000008137047919202906030000005362521192746809763_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002345063586288598060000002823823349596330141_",
    cx: -28.3689,
    cy: -1919.5172,
    r: 87.4525,
    gradientTransform: "matrix(-0.899 -0.4378 0.4378 -0.899 1411.0349 -1027.627)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000008137047919202906030000005362521192746809763_)",
      "fill": "url(#SVGID_00000002345063586288598060000002823823349596330141_)"
    },
    d: " M626.16,829.74c-0.67,0-1.28-0.45-1.45-1.13l-59.98-235.59c-0.21-0.8,0.28-1.62,1.08-1.82c0.8-0.2,1.62,0.28,1.82,1.08 l59.98,235.59c0.2,0.8-0.28,1.62-1.08,1.82C626.41,829.72,626.29,829.74,626.16,829.74z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000142170347940890728590000002641879910787867839_",
    cx: -28.3689,
    cy: -1919.5172,
    r: 87.4525,
    gradientTransform: "matrix(-0.899 -0.4378 0.4378 -0.899 1411.0349 -1027.627)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000142170347940890728590000002641879910787867839_)"
    },
    d: " M626.16,829.74c-0.67,0-1.28-0.45-1.45-1.13l-59.98-235.59c-0.21-0.8,0.28-1.62,1.08-1.82c0.8-0.2,1.62,0.28,1.82,1.08 l59.98,235.59c0.2,0.8-0.28,1.62-1.08,1.82C626.41,829.72,626.29,829.74,626.16,829.74z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000082352995276732418350000018091754606893195905_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 52.3,
    height: 296.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend91 || (_feBlend91 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 52.3,
    height: 296.48,
    id: "SVGID_00000052084330218871284480000006179386690270304941_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000082352995276732418350000018091754606893195905_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000159461145911849595750000000445341190130539169_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 52.3,
    height: 296.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend92 || (_feBlend92 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask46 || (_mask46 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 52.3,
    height: 296.48,
    id: "SVGID_00000052084330218871284480000006179386690270304941_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039125813461684685100000014266217513979975307_",
    cx: -139.128,
    cy: -1892.7334,
    r: 106.7072,
    gradientTransform: "matrix(-0.8597 -0.5108 0.5108 -0.8597 1438.0377 -958.8587)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000052084330218871284480000006179386690270304941_)",
      "fill": "url(#SVGID_00000039125813461684685100000014266217513979975307_)"
    },
    d: " M615.48,887.63c-0.72,0-1.35-0.52-1.48-1.25l-49.3-293.47c-0.14-0.82,0.41-1.59,1.23-1.73c0.81-0.14,1.59,0.41,1.73,1.23 l49.3,293.47c0.14,0.82-0.41,1.59-1.23,1.73C615.65,887.62,615.57,887.63,615.48,887.63z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000099621551272668050110000008066331592228683664_",
    cx: -139.128,
    cy: -1892.7334,
    r: 106.7072,
    gradientTransform: "matrix(-0.8597 -0.5108 0.5108 -0.8597 1438.0377 -958.8587)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000099621551272668050110000008066331592228683664_)"
    },
    d: " M615.48,887.63c-0.72,0-1.35-0.52-1.48-1.25l-49.3-293.47c-0.14-0.82,0.41-1.59,1.23-1.73c0.81-0.14,1.59,0.41,1.73,1.23 l49.3,293.47c0.14,0.82-0.41,1.59-1.23,1.73C615.65,887.62,615.57,887.63,615.48,887.63z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000066512709819681238420000012334864797825981606_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 23.29,
    height: 245.26
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend93 || (_feBlend93 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 23.29,
    height: 245.26,
    id: "SVGID_00000180354383128078106280000002964793254984261007_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000066512709819681238420000012334864797825981606_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052072039525987511900000001045346174451135404_",
    filterUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 23.29,
    height: 245.26
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend94 || (_feBlend94 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask47 || (_mask47 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.68,
    y: 591.14,
    width: 23.29,
    height: 245.26,
    id: "SVGID_00000180354383128078106280000002964793254984261007_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000149363025311007667140000011741322497691270072_",
    cx: -210.5105,
    cy: -1815.9155,
    r: 87.4439,
    gradientTransform: "matrix(-0.8145 -0.5802 0.5802 -0.8145 1458.4576 -887.4258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000180354383128078106280000002964793254984261007_)",
      "fill": "url(#SVGID_00000149363025311007667140000011741322497691270072_)"
    },
    d: " M586.47,836.4c-0.77,0-1.43-0.59-1.49-1.38l-20.29-242.26c-0.07-0.83,0.54-1.55,1.37-1.62c0.82-0.06,1.55,0.54,1.62,1.37 l20.29,242.26c0.07,0.83-0.54,1.55-1.37,1.62C586.55,836.4,586.51,836.4,586.47,836.4z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114067818642959486790000008882937018118664838_",
    cx: -210.5105,
    cy: -1815.9155,
    r: 87.4439,
    gradientTransform: "matrix(-0.8145 -0.5802 0.5802 -0.8145 1458.4576 -887.4258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000114067818642959486790000008882937018118664838_)"
    },
    d: " M586.47,836.4c-0.77,0-1.43-0.59-1.49-1.38l-20.29-242.26c-0.07-0.83,0.54-1.55,1.37-1.62c0.82-0.06,1.55,0.54,1.62,1.37 l20.29,242.26c0.07,0.83-0.54,1.55-1.37,1.62C586.55,836.4,586.51,836.4,586.47,836.4z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000158751088324472203930000011672499474711084177_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 3.2,
    height: 300.59
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend95 || (_feBlend95 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 3.2,
    height: 300.59,
    id: "SVGID_00000036248015499204387180000017658391375289105087_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000158751088324472203930000011672499474711084177_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000094596283977480090910000004745095856818480047_",
    filterUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 3.2,
    height: 300.59
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend96 || (_feBlend96 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask48 || (_mask48 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 564.69,
    y: 591.15,
    width: 3.2,
    height: 300.59,
    id: "SVGID_00000036248015499204387180000017658391375289105087_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114760173295612334990000007188475169371404929_",
    cx: -311.1399,
    cy: -1773.3564,
    r: 106.7139,
    gradientTransform: "matrix(-0.7636 -0.6456 0.6456 -0.7636 1473.5797 -813.5603)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000036248015499204387180000017658391375289105087_)",
      "fill": "url(#SVGID_00000114760173295612334990000007188475169371404929_)"
    },
    d: " M566.39,891.74c-0.83,0-1.5-0.67-1.5-1.5l-0.2-297.59c0-0.83,0.67-1.5,1.5-1.5h0c0.83,0,1.5,0.67,1.5,1.5l0.2,297.59 C567.89,891.07,567.21,891.74,566.39,891.74L566.39,891.74z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116232571765145583580000015189453570639723650_",
    cx: -311.1399,
    cy: -1773.3564,
    r: 106.7139,
    gradientTransform: "matrix(-0.7636 -0.6456 0.6456 -0.7636 1473.5797 -813.5603)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000116232571765145583580000015189453570639723650_)"
    },
    d: " M566.39,891.74c-0.83,0-1.5-0.67-1.5-1.5l-0.2-297.59c0-0.83,0.67-1.5,1.5-1.5h0c0.83,0,1.5,0.67,1.5,1.5l0.2,297.59 C567.89,891.07,567.21,891.74,566.39,891.74L566.39,891.74z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088132389088631922880000015850611940128880292_",
    filterUnits: "userSpaceOnUse",
    x: 544.72,
    y: 591.14,
    width: 22.97,
    height: 245.29
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend97 || (_feBlend97 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 544.72,
    y: 591.14,
    width: 22.97,
    height: 245.29,
    id: "SVGID_00000058548900020112829510000009152191198801439393_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000088132389088631922880000015850611940128880292_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088092455981652410510000002535568379050614415_",
    filterUnits: "userSpaceOnUse",
    x: 544.72,
    y: 591.14,
    width: 22.97,
    height: 245.29
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend98 || (_feBlend98 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask49 || (_mask49 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 544.72,
    y: 591.14,
    width: 22.97,
    height: 245.29,
    id: "SVGID_00000058548900020112829510000009152191198801439393_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000129185812155872423110000004696475692140530329_",
    cx: -372.3622,
    cy: -1682.7729,
    r: 87.4481,
    gradientTransform: "matrix(-0.7076 -0.7066 0.7066 -0.7076 1481.7626 -740.0549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000058548900020112829510000009152191198801439393_)",
      "fill": "url(#SVGID_00000129185812155872423110000004696475692140530329_)"
    },
    d: " M546.22,836.43c-0.04,0-0.08,0-0.12,0c-0.83-0.07-1.44-0.79-1.37-1.62l19.97-242.29c0.07-0.83,0.79-1.44,1.62-1.37 c0.83,0.07,1.44,0.79,1.37,1.62l-19.97,242.29C547.65,835.84,546.99,836.43,546.22,836.43z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093890337290585887700000009023439950893399447_",
    cx: -372.3622,
    cy: -1682.7729,
    r: 87.4481,
    gradientTransform: "matrix(-0.7076 -0.7066 0.7066 -0.7076 1481.7626 -740.0549)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000093890337290585887700000009023439950893399447_)"
    },
    d: " M546.22,836.43c-0.04,0-0.08,0-0.12,0c-0.83-0.07-1.44-0.79-1.37-1.62l19.97-242.29c0.07-0.83,0.79-1.44,1.62-1.37 c0.83,0.07,1.44,0.79,1.37,1.62l-19.97,242.29C547.65,835.84,546.99,836.43,546.22,836.43z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000008133105507920191960000007626477533539721377_",
    filterUnits: "userSpaceOnUse",
    x: 515.78,
    y: 591.15,
    width: 51.91,
    height: 296.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend99 || (_feBlend99 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 515.78,
    y: 591.15,
    width: 51.91,
    height: 296.54,
    id: "SVGID_00000103256913510214483750000012784574425641225125_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000008133105507920191960000007626477533539721377_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000006685796920154789360000001040437739955690650_",
    filterUnits: "userSpaceOnUse",
    x: 515.78,
    y: 591.15,
    width: 51.91,
    height: 296.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend100 || (_feBlend100 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask50 || (_mask50 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 515.78,
    y: 591.15,
    width: 51.91,
    height: 296.54,
    id: "SVGID_00000103256913510214483750000012784574425641225125_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000178895819301136942020000013465948300669140144_",
    cx: -461.5236,
    cy: -1628.1479,
    r: 106.71,
    gradientTransform: "matrix(-0.6466 -0.7628 0.7628 -0.6466 1485.2643 -665.3872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000103256913510214483750000012784574425641225125_)",
      "fill": "url(#SVGID_00000178895819301136942020000013465948300669140144_)"
    },
    d: " M517.28,887.69c-0.08,0-0.17-0.01-0.25-0.02c-0.82-0.14-1.37-0.91-1.23-1.73l48.91-293.54c0.14-0.82,0.92-1.37,1.73-1.23 c0.82,0.14,1.37,0.91,1.23,1.73l-48.91,293.54C518.64,887.17,518,887.69,517.28,887.69z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000133527506743084598130000000529034087861049987_",
    cx: -461.5236,
    cy: -1628.1479,
    r: 106.71,
    gradientTransform: "matrix(-0.6466 -0.7628 0.7628 -0.6466 1485.2643 -665.3872)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000133527506743084598130000000529034087861049987_)"
    },
    d: " M517.28,887.69c-0.08,0-0.17-0.01-0.25-0.02c-0.82-0.14-1.37-0.91-1.23-1.73l48.91-293.54c0.14-0.82,0.92-1.37,1.73-1.23 c0.82,0.14,1.37,0.91,1.23,1.73l-48.91,293.54C518.64,887.17,518,887.69,517.28,887.69z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000128481023923018848070000006077950220929543865_",
    filterUnits: "userSpaceOnUse",
    x: 505.01,
    y: 591.14,
    width: 62.67,
    height: 238.67
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend101 || (_feBlend101 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 505.01,
    y: 591.14,
    width: 62.67,
    height: 238.67,
    id: "SVGID_00000029044556860711183500000013398744053334785674_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000128481023923018848070000006077950220929543865_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000004539842221600394210000014965262541111604136_",
    filterUnits: "userSpaceOnUse",
    x: 505.01,
    y: 591.14,
    width: 62.67,
    height: 238.67
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend102 || (_feBlend102 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask51 || (_mask51 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 505.01,
    y: 591.14,
    width: 62.67,
    height: 238.67,
    id: "SVGID_00000029044556860711183500000013398744053334785674_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119811856815816306130000014269448393164546459_",
    cx: -510.1317,
    cy: -1525.424,
    r: 87.4465,
    gradientTransform: "matrix(-0.5813 -0.8137 0.8137 -0.5813 1481.0441 -591.3445)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000029044556860711183500000013398744053334785674_)",
      "fill": "url(#SVGID_00000119811856815816306130000014269448393164546459_)"
    },
    d: " M506.51,829.82c-0.12,0-0.25-0.01-0.37-0.05c-0.8-0.2-1.29-1.02-1.09-1.82l59.67-235.67c0.2-0.8,1.02-1.29,1.82-1.09 c0.8,0.2,1.29,1.02,1.09,1.82l-59.67,235.67C507.79,829.36,507.18,829.82,506.51,829.82z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000142883509001358273610000014348004340300107681_",
    cx: -510.1317,
    cy: -1525.424,
    r: 87.4465,
    gradientTransform: "matrix(-0.5813 -0.8137 0.8137 -0.5813 1481.0441 -591.3445)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000142883509001358273610000014348004340300107681_)"
    },
    d: " M506.51,829.82c-0.12,0-0.25-0.01-0.37-0.05c-0.8-0.2-1.29-1.02-1.09-1.82l59.67-235.67c0.2-0.8,1.02-1.29,1.82-1.09 c0.8,0.2,1.29,1.02,1.09,1.82l-59.67,235.67C507.79,829.36,507.18,829.82,506.51,829.82z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000136387693444917977150000008716801371462660529_",
    filterUnits: "userSpaceOnUse",
    x: 468.01,
    y: 591.15,
    width: 99.68,
    height: 284.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend103 || (_feBlend103 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 468.01,
    y: 591.15,
    width: 99.68,
    height: 284.44,
    id: "SVGID_00000073715223005284347090000002044013427402625975_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000136387693444917977150000008716801371462660529_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000066505528096930709360000005972608049250216125_",
    filterUnits: "userSpaceOnUse",
    x: 468.01,
    y: 591.15,
    width: 99.68,
    height: 284.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend104 || (_feBlend104 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask52 || (_mask52 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 468.01,
    y: 591.15,
    width: 99.68,
    height: 284.44,
    id: "SVGID_00000073715223005284347090000002044013427402625975_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000014601951679428708330000011811339191250362807_",
    cx: -585.9242,
    cy: -1459.2397,
    r: 106.7116,
    gradientTransform: "matrix(-0.5119 -0.859 0.859 -0.5119 1471.4032 -516.9177)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000073715223005284347090000002044013427402625975_)",
      "fill": "url(#SVGID_00000014601951679428708330000011811339191250362807_)"
    },
    d: " M469.51,875.6c-0.16,0-0.33-0.03-0.49-0.08c-0.78-0.27-1.2-1.12-0.93-1.91l96.68-281.45c0.27-0.78,1.12-1.2,1.91-0.93 c0.78,0.27,1.2,1.12,0.93,1.91l-96.68,281.45C470.72,875.21,470.14,875.6,469.51,875.6z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000024700620327569007070000004426338529673570955_",
    cx: -585.9242,
    cy: -1459.2397,
    r: 106.7116,
    gradientTransform: "matrix(-0.5119 -0.859 0.859 -0.5119 1471.4032 -516.9177)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000024700620327569007070000004426338529673570955_)"
    },
    d: " M469.51,875.6c-0.16,0-0.33-0.03-0.49-0.08c-0.78-0.27-1.2-1.12-0.93-1.91l96.68-281.45c0.27-0.78,1.12-1.2,1.91-0.93 c0.78,0.27,1.2,1.12,0.93,1.91l-96.68,281.45C470.72,875.21,470.14,875.6,469.51,875.6z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000002363108472664506850000004494605167113298842_",
    filterUnits: "userSpaceOnUse",
    x: 466.94,
    y: 591.14,
    width: 100.74,
    height: 225.6
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend105 || (_feBlend105 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 466.94,
    y: 591.14,
    width: 100.74,
    height: 225.6,
    id: "SVGID_00000129191463981182582160000008806389983921738941_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000002363108472664506850000004494605167113298842_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000121246830280178035390000012928582904637851319_",
    filterUnits: "userSpaceOnUse",
    x: 466.94,
    y: 591.14,
    width: 100.74,
    height: 225.6
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend106 || (_feBlend106 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask53 || (_mask53 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 466.94,
    y: 591.14,
    width: 100.74,
    height: 225.6,
    id: "SVGID_00000129191463981182582160000008806389983921738941_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000052783436198832578200000002397383159462739107_",
    cx: -619.5535,
    cy: -1347.7859,
    r: 87.4463,
    gradientTransform: "matrix(-0.439 -0.8985 0.8985 -0.439 1456.3124 -444.4073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000129191463981182582160000008806389983921738941_)",
      "fill": "url(#SVGID_00000052783436198832578200000002397383159462739107_)"
    },
    d: " M468.44,816.74c-0.2,0-0.41-0.04-0.6-0.13c-0.76-0.33-1.1-1.22-0.77-1.98l97.74-222.6c0.33-0.76,1.22-1.11,1.98-0.77 c0.76,0.33,1.1,1.22,0.77,1.98l-97.74,222.6C469.57,816.4,469.02,816.74,468.44,816.74z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000932718818734737760000001703300337443000992_",
    cx: -619.5535,
    cy: -1347.7859,
    r: 87.4463,
    gradientTransform: "matrix(-0.439 -0.8985 0.8985 -0.439 1456.3124 -444.4073)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000000932718818734737760000001703300337443000992_)"
    },
    d: " M468.44,816.74c-0.2,0-0.41-0.04-0.6-0.13c-0.76-0.33-1.1-1.22-0.77-1.98l97.74-222.6c0.33-0.76,1.22-1.11,1.98-0.77 c0.76,0.33,1.1,1.22,0.77,1.98l-97.74,222.6C469.57,816.4,469.02,816.74,468.44,816.74z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000003098707849814208080000011324036030754266007_",
    filterUnits: "userSpaceOnUse",
    x: 422.9,
    y: 591.15,
    width: 144.79,
    height: 264.64
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend107 || (_feBlend107 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 422.9,
    y: 591.15,
    width: 144.79,
    height: 264.64,
    id: "SVGID_00000107558056181005722210000016015424762425721252_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000003098707849814208080000011324036030754266007_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000032629752520847534410000015733996179337142968_",
    filterUnits: "userSpaceOnUse",
    x: 422.9,
    y: 591.15,
    width: 144.79,
    height: 264.64
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend108 || (_feBlend108 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask54 || (_mask54 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 422.9,
    y: 591.15,
    width: 144.79,
    height: 264.64,
    id: "SVGID_00000107558056181005722210000016015424762425721252_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000010301892560405421330000001510847566007792544_",
    cx: -680.3439,
    cy: -1272.8059,
    r: 106.7131,
    gradientTransform: "matrix(-0.3631 -0.9317 0.9317 -0.3631 1434.1333 -372.5616)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000107558056181005722210000016015424762425721252_)",
      "fill": "url(#SVGID_00000010301892560405421330000001510847566007792544_)"
    },
    d: " M424.4,855.79c-0.24,0-0.49-0.06-0.71-0.18c-0.73-0.39-1-1.3-0.6-2.03l141.79-261.64c0.4-0.73,1.3-1,2.03-0.6 c0.73,0.39,1,1.3,0.6,2.03L425.72,855C425.44,855.5,424.93,855.79,424.4,855.79z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000081608292548536522930000012271970045554536611_",
    cx: -680.3439,
    cy: -1272.8059,
    r: 106.7131,
    gradientTransform: "matrix(-0.3631 -0.9317 0.9317 -0.3631 1434.1333 -372.5616)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000081608292548536522930000012271970045554536611_)"
    },
    d: " M424.4,855.79c-0.24,0-0.49-0.06-0.71-0.18c-0.73-0.39-1-1.3-0.6-2.03l141.79-261.64c0.4-0.73,1.3-1,2.03-0.6 c0.73,0.39,1,1.3,0.6,2.03L425.72,855C425.44,855.5,424.93,855.79,424.4,855.79z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000173155351845027558380000016043374489115443646_",
    filterUnits: "userSpaceOnUse",
    x: 431.55,
    y: 591.14,
    width: 136.13,
    height: 206.42
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend109 || (_feBlend109 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 431.55,
    y: 591.14,
    width: 136.13,
    height: 206.42,
    id: "SVGID_00000116953079428473142470000000132890261988110261_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000173155351845027558380000016043374489115443646_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000061465111575650276650000004074115311435306159_",
    filterUnits: "userSpaceOnUse",
    x: 431.55,
    y: 591.14,
    width: 136.13,
    height: 206.42
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend110 || (_feBlend110 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask55 || (_mask55 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 431.55,
    y: 591.14,
    width: 136.13,
    height: 206.42,
    id: "SVGID_00000116953079428473142470000000132890261988110261_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000133523121544197094270000013580592659788999312_",
    cx: -699.0253,
    cy: -1153.3711,
    r: 87.4458,
    gradientTransform: "matrix(-0.2848 -0.9586 0.9586 -0.2848 1406.1555 -304.2149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000116953079428473142470000000132890261988110261_)",
      "fill": "url(#SVGID_00000133523121544197094270000013580592659788999312_)"
    },
    d: " M433.05,797.56c-0.28,0-0.57-0.08-0.82-0.25c-0.69-0.45-0.89-1.38-0.43-2.08l133.13-203.42c0.46-0.69,1.39-0.89,2.08-0.43 c0.69,0.45,0.89,1.38,0.43,2.08L434.31,796.88C434.02,797.32,433.54,797.56,433.05,797.56z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000062162428313931412560000004375175216190613125_",
    cx: -699.0253,
    cy: -1153.3711,
    r: 87.4458,
    gradientTransform: "matrix(-0.2848 -0.9586 0.9586 -0.2848 1406.1555 -304.2149)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000062162428313931412560000004375175216190613125_)"
    },
    d: " M433.05,797.56c-0.28,0-0.57-0.08-0.82-0.25c-0.69-0.45-0.89-1.38-0.43-2.08l133.13-203.42c0.46-0.69,1.39-0.89,2.08-0.43 c0.69,0.45,0.89,1.38,0.43,2.08L434.31,796.88C434.02,797.32,433.54,797.56,433.05,797.56z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000102519980476874931060000001142025984583716511_",
    filterUnits: "userSpaceOnUse",
    x: 381.67,
    y: 591.15,
    width: 186.02,
    height: 237.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend111 || (_feBlend111 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 381.67,
    y: 591.15,
    width: 186.02,
    height: 237.65,
    id: "SVGID_00000061432412665663865540000001274600181564028600_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000102519980476874931060000001142025984583716511_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000152227732220067657770000004922951762896227220_",
    filterUnits: "userSpaceOnUse",
    x: 381.67,
    y: 591.15,
    width: 186.02,
    height: 237.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend112 || (_feBlend112 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask56 || (_mask56 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 381.67,
    y: 591.15,
    width: 186.02,
    height: 237.65,
    id: "SVGID_00000061432412665663865540000001274600181564028600_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000071518340850368230440000013088872527564980126_",
    cx: -743.4006,
    cy: -1073.4257,
    r: 106.7068,
    gradientTransform: "matrix(-0.2044 -0.9789 0.9789 -0.2044 1373.504 -237.1439)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000061432412665663865540000001274600181564028600_)",
      "fill": "url(#SVGID_00000071518340850368230440000013088872527564980126_)"
    },
    d: " M383.17,828.81c-0.32,0-0.65-0.1-0.92-0.32c-0.65-0.51-0.77-1.45-0.26-2.11l183.02-234.65c0.51-0.65,1.45-0.77,2.11-0.26 c0.65,0.51,0.77,1.45,0.26,2.11L384.35,828.23C384.06,828.61,383.61,828.81,383.17,828.81z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096768952614263979400000006760059241901269894_",
    cx: -743.4006,
    cy: -1073.4257,
    r: 106.7068,
    gradientTransform: "matrix(-0.2044 -0.9789 0.9789 -0.2044 1373.504 -237.1439)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000096768952614263979400000006760059241901269894_)"
    },
    d: " M383.17,828.81c-0.32,0-0.65-0.1-0.92-0.32c-0.65-0.51-0.77-1.45-0.26-2.11l183.02-234.65c0.51-0.65,1.45-0.77,2.11-0.26 c0.65,0.51,0.77,1.45,0.26,2.11L384.35,828.23C384.06,828.61,383.61,828.81,383.17,828.81z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000127033347456301605620000007306507619925840035_",
    filterUnits: "userSpaceOnUse",
    x: 399.81,
    y: 591.14,
    width: 167.87,
    height: 181.66
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend113 || (_feBlend113 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 399.81,
    y: 591.14,
    width: 167.87,
    height: 181.66,
    id: "SVGID_00000078748157653013336390000017456291521266696322_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000127033347456301605620000007306507619925840035_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000039124721996741721250000008344542951404780686_",
    filterUnits: "userSpaceOnUse",
    x: 399.81,
    y: 591.14,
    width: 167.87,
    height: 181.66
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend114 || (_feBlend114 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask57 || (_mask57 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 399.81,
    y: 591.14,
    width: 167.87,
    height: 181.66,
    id: "SVGID_00000078748157653013336390000017456291521266696322_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000038383535559613249300000016268748716503476125_",
    cx: -744.4446,
    cy: -948.8564,
    r: 87.4508,
    gradientTransform: "matrix(-0.1227 -0.9924 0.9924 -0.1227 1334.048 -173.2387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000078748157653013336390000017456291521266696322_)",
      "fill": "url(#SVGID_00000038383535559613249300000016268748716503476125_)"
    },
    d: " M401.31,772.8c-0.36,0-0.73-0.13-1.02-0.4c-0.61-0.56-0.65-1.51-0.08-2.12l164.87-178.66c0.56-0.61,1.51-0.64,2.12-0.09 c0.61,0.56,0.65,1.51,0.08,2.12L402.41,772.32C402.12,772.64,401.71,772.8,401.31,772.8z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000099655188419843839330000013183056754566388885_",
    cx: -744.4446,
    cy: -948.8564,
    r: 87.4508,
    gradientTransform: "matrix(-0.1227 -0.9924 0.9924 -0.1227 1334.048 -173.2387)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000099655188419843839330000013183056754566388885_)"
    },
    d: " M401.31,772.8c-0.36,0-0.73-0.13-1.02-0.4c-0.61-0.56-0.65-1.51-0.08-2.12l164.87-178.66c0.56-0.61,1.51-0.64,2.12-0.09 c0.61,0.56,0.65,1.51,0.08,2.12L402.41,772.32C402.12,772.64,401.71,772.8,401.31,772.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000101803683195355983180000009295089509133075626_",
    filterUnits: "userSpaceOnUse",
    x: 345.46,
    y: 591.15,
    width: 222.23,
    height: 204.24
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend115 || (_feBlend115 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 345.46,
    y: 591.15,
    width: 222.23,
    height: 204.24,
    id: "SVGID_00000157310676489915471200000018413993590009652635_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000101803683195355983180000009295089509133075626_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000142866630426964172600000001018021842840968365_",
    filterUnits: "userSpaceOnUse",
    x: 345.46,
    y: 591.15,
    width: 222.23,
    height: 204.24
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend116 || (_feBlend116 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask58 || (_mask58 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 345.46,
    y: 591.15,
    width: 222.23,
    height: 204.24,
    id: "SVGID_00000157310676489915471200000018413993590009652635_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000030485877649417802530000011588992769204380575_",
    cx: -772.3497,
    cy: -865.8471,
    r: 106.7075,
    gradientTransform: "matrix(-0.0401 -0.9992 0.9992 -0.0401 1290.7566 -113.1805)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000157310676489915471200000018413993590009652635_)",
      "fill": "url(#SVGID_00000030485877649417802530000011588992769204380575_)"
    },
    d: " M346.96,795.39c-0.41,0-0.81-0.16-1.11-0.49c-0.56-0.61-0.52-1.56,0.09-2.12l219.23-201.24c0.61-0.56,1.56-0.52,2.12,0.09 c0.56,0.61,0.52,1.56-0.09,2.12L347.97,794.99C347.68,795.26,347.32,795.39,346.96,795.39z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000144297747975379752620000004080078210824433294_",
    cx: -772.3497,
    cy: -865.8471,
    r: 106.7075,
    gradientTransform: "matrix(-0.0401 -0.9992 0.9992 -0.0401 1290.7566 -113.1805)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000144297747975379752620000004080078210824433294_)"
    },
    d: " M346.96,795.39c-0.41,0-0.81-0.16-1.11-0.49c-0.56-0.61-0.52-1.56,0.09-2.12l219.23-201.24c0.61-0.56,1.56-0.52,2.12,0.09 c0.56,0.61,0.52,1.56-0.09,2.12L347.97,794.99C347.68,795.26,347.32,795.39,346.96,795.39z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000067198161438022648640000014880379103009648771_",
    filterUnits: "userSpaceOnUse",
    x: 372.59,
    y: 591.14,
    width: 195.09,
    height: 152.01
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend117 || (_feBlend117 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 372.59,
    y: 591.14,
    width: 195.09,
    height: 152.01,
    id: "SVGID_00000022534213768786322380000004400540516654851463_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000067198161438022648640000014880379103009648771_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065052427391165820020000005271978800294705065_",
    filterUnits: "userSpaceOnUse",
    x: 372.59,
    y: 591.14,
    width: 195.09,
    height: 152.01
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend118 || (_feBlend118 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask59 || (_mask59 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 372.59,
    y: 591.14,
    width: 195.09,
    height: 152.01,
    id: "SVGID_00000022534213768786322380000004400540516654851463_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000016758341277682547160000009198020525905482655_",
    cx: -755.9894,
    cy: -740.6807,
    r: 87.446,
    gradientTransform: "matrix(0.0428 -0.9991 0.9991 0.0428 1242.5062 -56.4627)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000022534213768786322380000004400540516654851463_)",
      "fill": "url(#SVGID_00000016758341277682547160000009198020525905482655_)"
    },
    d: " M374.09,743.15c-0.45,0-0.89-0.2-1.19-0.58c-0.51-0.65-0.39-1.6,0.27-2.1l192.09-149.01c0.65-0.51,1.6-0.39,2.1,0.27 c0.51,0.65,0.39,1.6-0.27,2.1L375.01,742.83C374.73,743.05,374.41,743.15,374.09,743.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157299136130348695370000009516922992890709671_",
    cx: -755.9894,
    cy: -740.6807,
    r: 87.446,
    gradientTransform: "matrix(0.0428 -0.9991 0.9991 0.0428 1242.5062 -56.4627)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000157299136130348695370000009516922992890709671_)"
    },
    d: " M374.09,743.15c-0.45,0-0.89-0.2-1.19-0.58c-0.51-0.65-0.39-1.6,0.27-2.1l192.09-149.01c0.65-0.51,1.6-0.39,2.1,0.27 c0.51,0.65,0.39,1.6-0.27,2.1L375.01,742.83C374.73,743.05,374.41,743.15,374.09,743.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000004526473644756375420000013939968349159190929_",
    filterUnits: "userSpaceOnUse",
    x: 315.26,
    y: 591.15,
    width: 252.43,
    height: 165.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend119 || (_feBlend119 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 315.26,
    y: 591.15,
    width: 252.43,
    height: 165.3,
    id: "SVGID_00000064331772217612965380000011565427317567082675_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000004526473644756375420000013939968349159190929_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000013915712676348491440000017422080175578178695_",
    filterUnits: "userSpaceOnUse",
    x: 315.26,
    y: 591.15,
    width: 252.43,
    height: 165.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend120 || (_feBlend120 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask60 || (_mask60 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 315.26,
    y: 591.15,
    width: 252.43,
    height: 165.3,
    id: "SVGID_00000064331772217612965380000011565427317567082675_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000048484917684766760220000008430252686814721204_",
    cx: -766.5605,
    cy: -656.2861,
    r: 106.71,
    gradientTransform: "matrix(0.1253 -0.9921 0.9921 0.1253 1188.6246 -4.4678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000064331772217612965380000011565427317567082675_)",
      "fill": "url(#SVGID_00000048484917684766760220000008430252686814721204_)"
    },
    d: " M316.76,756.46c-0.49,0-0.97-0.24-1.26-0.68c-0.45-0.69-0.26-1.62,0.44-2.08l249.43-162.3c0.69-0.45,1.62-0.26,2.08,0.44 c0.45,0.69,0.26,1.62-0.44,2.08l-249.43,162.3C317.32,756.38,317.04,756.46,316.76,756.46z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000132788390456381612830000006737567635153708704_",
    cx: -766.5605,
    cy: -656.2861,
    r: 106.71,
    gradientTransform: "matrix(0.1253 -0.9921 0.9921 0.1253 1188.6246 -4.4678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000132788390456381612830000006737567635153708704_)"
    },
    d: " M316.76,756.46c-0.49,0-0.97-0.24-1.26-0.68c-0.45-0.69-0.26-1.62,0.44-2.08l249.43-162.3c0.69-0.45,1.62-0.26,2.08,0.44 c0.45,0.69,0.26,1.62-0.44,2.08l-249.43,162.3C317.32,756.38,317.04,756.46,316.76,756.46z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000008120672259125562060000011236066874867378078_",
    filterUnits: "userSpaceOnUse",
    x: 350.64,
    y: 591.14,
    width: 217.05,
    height: 118.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend121 || (_feBlend121 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 350.64,
    y: 591.14,
    width: 217.05,
    height: 118.27,
    id: "SVGID_00000023985018427498444830000004001382236422217650_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000008120672259125562060000011236066874867378078_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000067197086144403657960000005686288125347613574_",
    filterUnits: "userSpaceOnUse",
    x: 350.64,
    y: 591.14,
    width: 217.05,
    height: 118.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend122 || (_feBlend122 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask61 || (_mask61 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 350.64,
    y: 591.14,
    width: 217.05,
    height: 118.27,
    id: "SVGID_00000023985018427498444830000004001382236422217650_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000030454914798757385690000013639724861599548569_",
    cx: -732.9443,
    cy: -531.8099,
    r: 87.4509,
    gradientTransform: "matrix(0.207 -0.9783 0.9783 0.207 1131.1479 43.3207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000023985018427498444830000004001382236422217650_)",
      "fill": "url(#SVGID_00000030454914798757385690000013639724861599548569_)"
    },
    d: " M352.14,709.41c-0.53,0-1.05-0.29-1.32-0.79c-0.39-0.73-0.12-1.64,0.61-2.03l214.05-115.27c0.73-0.39,1.64-0.12,2.03,0.61 c0.39,0.73,0.12,1.64-0.61,2.03L352.85,709.23C352.62,709.35,352.38,709.41,352.14,709.41z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000037683066456663690140000018246376062456838538_",
    cx: -732.9443,
    cy: -531.8099,
    r: 87.4509,
    gradientTransform: "matrix(0.207 -0.9783 0.9783 0.207 1131.1479 43.3207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000037683066456663690140000018246376062456838538_)"
    },
    d: " M352.14,709.41c-0.53,0-1.05-0.29-1.32-0.79c-0.39-0.73-0.12-1.64,0.61-2.03l214.05-115.27c0.73-0.39,1.64-0.12,2.03,0.61 c0.39,0.73,0.12,1.64-0.61,2.03L352.85,709.23C352.62,709.35,352.38,709.41,352.14,709.41z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000046330905271112738250000011887437240522849158_",
    filterUnits: "userSpaceOnUse",
    x: 291.89,
    y: 591.15,
    width: 275.79,
    height: 121.92
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend123 || (_feBlend123 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 291.89,
    y: 591.15,
    width: 275.79,
    height: 121.92,
    id: "SVGID_00000157991933293761976040000000404086553025537933_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000046330905271112738250000011887437240522849158_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065786831454488493240000011627704735762016924_",
    filterUnits: "userSpaceOnUse",
    x: 291.89,
    y: 591.15,
    width: 275.79,
    height: 121.92
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend124 || (_feBlend124 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask62 || (_mask62 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 291.89,
    y: 591.15,
    width: 275.79,
    height: 121.92,
    id: "SVGID_00000157991933293761976040000000404086553025537933_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157271736777912406060000006331188176149264524_",
    cx: -726.0458,
    cy: -450.8534,
    r: 106.7122,
    gradientTransform: "matrix(0.2873 -0.9578 0.9578 0.2873 1070.2125 86.2364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000157991933293761976040000000404086553025537933_)",
      "fill": "url(#SVGID_00000157271736777912406060000006331188176149264524_)"
    },
    d: " M293.4,713.07c-0.58,0-1.13-0.34-1.38-0.9c-0.33-0.76,0.02-1.64,0.78-1.97l272.79-118.92c0.76-0.33,1.64,0.02,1.97,0.78 c0.33,0.76-0.02,1.64-0.78,1.97L293.99,712.95C293.8,713.03,293.6,713.07,293.4,713.07z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000154387862395517439540000002429358753635967116_",
    cx: -726.0458,
    cy: -450.8534,
    r: 106.7122,
    gradientTransform: "matrix(0.2873 -0.9578 0.9578 0.2873 1070.2125 86.2364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000154387862395517439540000002429358753635967116_)"
    },
    d: " M293.4,713.07c-0.58,0-1.13-0.34-1.38-0.9c-0.33-0.76,0.02-1.64,0.78-1.97l272.79-118.92c0.76-0.33,1.64,0.02,1.97,0.78 c0.33,0.76-0.02,1.64-0.78,1.97L293.99,712.95C293.8,713.03,293.6,713.07,293.4,713.07z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000003090633790486190200000014152070660845763996_",
    filterUnits: "userSpaceOnUse",
    x: 334.55,
    y: 591.14,
    width: 233.13,
    height: 81.37
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend125 || (_feBlend125 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 334.55,
    y: 591.14,
    width: 233.13,
    height: 81.37,
    id: "SVGID_00000178923539288528489560000005914369936469441924_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000003090633790486190200000014152070660845763996_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000022523427687010521280000000582838651406598045_",
    filterUnits: "userSpaceOnUse",
    x: 334.55,
    y: 591.14,
    width: 233.13,
    height: 81.37
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend126 || (_feBlend126 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask63 || (_mask63 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 334.55,
    y: 591.14,
    width: 233.13,
    height: 81.37,
    id: "SVGID_00000178923539288528489560000005914369936469441924_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075129140858859431080000016016520942674801046_",
    cx: -676.4111,
    cy: -330.7961,
    r: 87.4448,
    gradientTransform: "matrix(0.3656 -0.9308 0.9308 0.3656 1006.3174 123.1611)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000178923539288528489560000005914369936469441924_)",
      "fill": "url(#SVGID_00000075129140858859431080000016016520942674801046_)"
    },
    d: " M336.05,672.51c-0.62,0-1.21-0.39-1.42-1.02c-0.27-0.78,0.15-1.64,0.94-1.9l230.13-78.37c0.78-0.27,1.64,0.15,1.9,0.94 c0.27,0.78-0.15,1.64-0.94,1.9l-230.13,78.37C336.37,672.48,336.21,672.51,336.05,672.51z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000086657713877001955000000001405754187658908840_",
    cx: -676.4111,
    cy: -330.7961,
    r: 87.4448,
    gradientTransform: "matrix(0.3656 -0.9308 0.9308 0.3656 1006.3174 123.1611)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000086657713877001955000000001405754187658908840_)"
    },
    d: " M336.05,672.51c-0.62,0-1.21-0.39-1.42-1.02c-0.27-0.78,0.15-1.64,0.94-1.9l230.13-78.37c0.78-0.27,1.64,0.15,1.9,0.94 c0.27,0.78-0.15,1.64-0.94,1.9l-230.13,78.37C336.37,672.48,336.21,672.51,336.05,672.51z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000022530136265915322780000002132757186424838588_",
    filterUnits: "userSpaceOnUse",
    x: 276.01,
    y: 591.15,
    width: 291.68,
    height: 75.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend127 || (_feBlend127 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 276.01,
    y: 591.15,
    width: 291.68,
    height: 75.28,
    id: "SVGID_00000092432006133979220130000005678678766922543547_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000022530136265915322780000002132757186424838588_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000141414649812141995380000013715354473666138520_",
    filterUnits: "userSpaceOnUse",
    x: 276.01,
    y: 591.15,
    width: 291.68,
    height: 75.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend128 || (_feBlend128 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask64 || (_mask64 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 276.01,
    y: 591.15,
    width: 291.68,
    height: 75.28,
    id: "SVGID_00000092432006133979220130000005678678766922543547_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000123429412577138631910000016090907164673673630_",
    cx: -652.8288,
    cy: -254.9477,
    r: 106.7085,
    gradientTransform: "matrix(0.4414 -0.8973 0.8973 0.4414 938.7736 155.5425)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000092432006133979220130000005678678766922543547_)",
      "fill": "url(#SVGID_00000123429412577138631910000016090907164673673630_)"
    },
    d: " M277.51,666.43c-0.67,0-1.28-0.45-1.45-1.14c-0.2-0.8,0.29-1.62,1.09-1.82l288.68-72.28c0.8-0.2,1.62,0.29,1.82,1.09 c0.2,0.8-0.29,1.62-1.09,1.82l-288.68,72.28C277.75,666.41,277.63,666.43,277.51,666.43z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000108272350323206054460000006781391763692160420_",
    cx: -652.8288,
    cy: -254.9477,
    r: 106.7085,
    gradientTransform: "matrix(0.4414 -0.8973 0.8973 0.4414 938.7736 155.5425)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000108272350323206054460000006781391763692160420_)"
    },
    d: " M277.51,666.43c-0.67,0-1.28-0.45-1.45-1.14c-0.2-0.8,0.29-1.62,1.09-1.82l288.68-72.28c0.8-0.2,1.62,0.29,1.82,1.09 c0.2,0.8-0.29,1.62-1.09,1.82l-288.68,72.28C277.75,666.41,277.63,666.43,277.51,666.43z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000045579523713604910640000000884614962849280149_",
    filterUnits: "userSpaceOnUse",
    x: 324.77,
    y: 591.14,
    width: 242.91,
    height: 42.32
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend129 || (_feBlend129 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 324.77,
    y: 591.14,
    width: 242.91,
    height: 42.32,
    id: "SVGID_00000137132291511518535630000003999618357787921084_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000045579523713604910640000000884614962849280149_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000090290883057541176540000008907982703235611551_",
    filterUnits: "userSpaceOnUse",
    x: 324.77,
    y: 591.14,
    width: 242.91,
    height: 42.32
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend130 || (_feBlend130 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask65 || (_mask65 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 324.77,
    y: 591.14,
    width: 242.91,
    height: 42.32,
    id: "SVGID_00000137132291511518535630000003999618357787921084_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170968921173110897770000000595418044085741445_",
    cx: -586.6709,
    cy: -141.7787,
    r: 87.4448,
    gradientTransform: "matrix(0.5142 -0.8577 0.8577 0.5142 869.4979 182.017)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000137132291511518535630000003999618357787921084_)",
      "fill": "url(#SVGID_00000170968921173110897770000000595418044085741445_)"
    },
    d: " M326.27,633.46c-0.72,0-1.36-0.52-1.48-1.26c-0.13-0.82,0.42-1.59,1.24-1.72l239.91-39.32c0.82-0.13,1.59,0.42,1.72,1.24 c0.13,0.82-0.42,1.59-1.24,1.72l-239.91,39.32C326.43,633.46,326.35,633.46,326.27,633.46z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000162313146911378440840000008689353040840704138_",
    cx: -586.6709,
    cy: -141.7787,
    r: 87.4448,
    gradientTransform: "matrix(0.5142 -0.8577 0.8577 0.5142 869.4979 182.017)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000162313146911378440840000008689353040840704138_)"
    },
    d: " M326.27,633.46c-0.72,0-1.36-0.52-1.48-1.26c-0.13-0.82,0.42-1.59,1.24-1.72l239.91-39.32c0.82-0.13,1.59,0.42,1.72,1.24 c0.13,0.82-0.42,1.59-1.24,1.72l-239.91,39.32C326.43,633.46,326.35,633.46,326.27,633.46z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000097473942586513100020000008918310368708691885_",
    filterUnits: "userSpaceOnUse",
    x: 268.04,
    y: 591.15,
    width: 299.65,
    height: 26.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend131 || (_feBlend131 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 268.04,
    y: 591.15,
    width: 299.65,
    height: 26.65,
    id: "SVGID_00000119817389517525738120000017194538542519101364_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000097473942586513100020000008918310368708691885_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000078009716834579022020000005118832341312373174_",
    filterUnits: "userSpaceOnUse",
    x: 268.04,
    y: 591.15,
    width: 299.65,
    height: 26.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend132 || (_feBlend132 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask66 || (_mask66 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 268.04,
    y: 591.15,
    width: 299.65,
    height: 26.65,
    id: "SVGID_00000119817389517525738120000017194538542519101364_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000011735363153129185830000000158477850319967643_",
    cx: -548.3001,
    cy: -73.7638,
    r: 106.7047,
    gradientTransform: "matrix(0.5834 -0.8122 0.8122 0.5834 797.653 202.1868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000119817389517525738120000017194538542519101364_)",
      "fill": "url(#SVGID_00000011735363153129185830000000158477850319967643_)"
    },
    d: " M269.54,617.8c-0.77,0-1.43-0.6-1.49-1.38c-0.07-0.83,0.55-1.55,1.38-1.61l296.65-23.65c0.8-0.06,1.55,0.55,1.61,1.38 c0.07,0.83-0.55,1.55-1.38,1.61L269.66,617.8C269.62,617.8,269.58,617.8,269.54,617.8z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000062190852142364289770000017066462013316586426_",
    cx: -548.3001,
    cy: -73.7638,
    r: 106.7047,
    gradientTransform: "matrix(0.5834 -0.8122 0.8122 0.5834 797.653 202.1868)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000062190852142364289770000017066462013316586426_)"
    },
    d: " M269.54,617.8c-0.77,0-1.43-0.6-1.49-1.38c-0.07-0.83,0.55-1.55,1.38-1.61l296.65-23.65c0.8-0.06,1.55,0.55,1.61,1.38 c0.07,0.83-0.55,1.55-1.38,1.61L269.66,617.8C269.62,617.8,269.58,617.8,269.54,617.8z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000055675797744322027980000012497949263444619167_",
    filterUnits: "userSpaceOnUse",
    x: 321.57,
    y: 590.34,
    width: 246.11,
    height: 3.81
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend133 || (_feBlend133 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 321.57,
    y: 590.34,
    width: 246.11,
    height: 3.81,
    id: "SVGID_00000146467130534741992900000007636386881827206815_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000055675797744322027980000012497949263444619167_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026135043276968059830000001920444862912233143_",
    filterUnits: "userSpaceOnUse",
    x: 321.57,
    y: 590.34,
    width: 246.11,
    height: 3.81
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend134 || (_feBlend134 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask67 || (_mask67 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 321.57,
    y: 590.34,
    width: 246.11,
    height: 3.81,
    id: "SVGID_00000146467130534741992900000007636386881827206815_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078740305841821872870000000212835718093181844_",
    cx: -467.1533,
    cy: 29.8208,
    r: 87.4435,
    gradientTransform: "matrix(0.6487 -0.7611 0.7611 0.6487 724.9738 217.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000146467130534741992900000007636386881827206815_)",
      "fill": "url(#SVGID_00000078740305841821872870000000212835718093181844_)"
    },
    d: " M566.18,594.14L566.18,594.14l-243.11-0.81c-0.83,0-1.5-0.68-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5h0l243.11,0.81 c0.83,0,1.5,0.68,1.5,1.5C567.68,593.47,567.01,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170276934788791573910000015368972078931964855_",
    cx: -467.1533,
    cy: 29.8208,
    r: 87.4435,
    gradientTransform: "matrix(0.6487 -0.7611 0.7611 0.6487 724.9738 217.344)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000170276934788791573910000015368972078931964855_)"
    },
    d: " M566.18,594.14L566.18,594.14l-243.11-0.81c-0.83,0-1.5-0.68-1.5-1.5c0-0.83,0.67-1.5,1.5-1.5h0l243.11,0.81 c0.83,0,1.5,0.68,1.5,1.5C567.68,593.47,567.01,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000018929172069060735480000005468955747404354189_",
    filterUnits: "userSpaceOnUse",
    x: 268.21,
    y: 565.53,
    width: 299.48,
    height: 28.62
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend135 || (_feBlend135 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 268.21,
    y: 565.53,
    width: 299.48,
    height: 28.62,
    id: "SVGID_00000127723613184241749630000000757303537921279905_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000018929172069060735480000005468955747404354189_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000153684781213419566570000011310894793697807244_",
    filterUnits: "userSpaceOnUse",
    x: 268.21,
    y: 565.53,
    width: 299.48,
    height: 28.62
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend136 || (_feBlend136 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask68 || (_mask68 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 268.21,
    y: 565.53,
    width: 299.48,
    height: 28.62,
    id: "SVGID_00000127723613184241749630000000757303537921279905_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075129379251363890270000018276937633084685226_",
    cx: -414.9131,
    cy: 86.7643,
    r: 106.7008,
    gradientTransform: "matrix(0.7095 -0.7048 0.7048 0.7095 651.177 225.8523)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000127723613184241749630000000757303537921279905_)",
      "fill": "url(#SVGID_00000075129379251363890270000018276937633084685226_)"
    },
    d: " M566.19,594.15c-0.04,0-0.09,0-0.13-0.01l-296.48-25.62c-0.83-0.07-1.44-0.8-1.37-1.62c0.07-0.83,0.8-1.44,1.62-1.37 l296.48,25.62c0.83,0.07,1.44,0.8,1.37,1.62C567.62,593.56,566.96,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000091737781580954209480000010541665244525996192_",
    cx: -414.9131,
    cy: 86.7643,
    r: 106.7008,
    gradientTransform: "matrix(0.7095 -0.7048 0.7048 0.7095 651.177 225.8523)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000091737781580954209480000010541665244525996192_)"
    },
    d: " M566.19,594.15c-0.04,0-0.09,0-0.13-0.01l-296.48-25.62c-0.83-0.07-1.44-0.8-1.37-1.62c0.07-0.83,0.8-1.44,1.62-1.37 l296.48,25.62c0.83,0.07,1.44,0.8,1.37,1.62C567.62,593.56,566.96,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000062880367241292077370000015412857476716539573_",
    filterUnits: "userSpaceOnUse",
    x: 325.04,
    y: 550.23,
    width: 242.64,
    height: 43.91
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend137 || (_feBlend137 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 325.04,
    y: 550.23,
    width: 242.64,
    height: 43.91,
    id: "SVGID_00000003799917175619941040000006426122757849939358_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000062880367241292077370000015412857476716539573_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156589286768032259250000003867375122626968743_",
    filterUnits: "userSpaceOnUse",
    x: 325.04,
    y: 550.23,
    width: 242.64,
    height: 43.91
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend138 || (_feBlend138 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask69 || (_mask69 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 325.04,
    y: 550.23,
    width: 242.64,
    height: 43.91,
    id: "SVGID_00000003799917175619941040000006426122757849939358_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039099027363185446160000009457965556941932959_",
    cx: -320.6239,
    cy: 179.4993,
    r: 87.4435,
    gradientTransform: "matrix(0.7654 -0.6436 0.6436 0.7654 576.242 228.4465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000003799917175619941040000006426122757849939358_)",
      "fill": "url(#SVGID_00000039099027363185446160000009457965556941932959_)"
    },
    d: " M566.18,594.14c-0.08,0-0.17-0.01-0.25-0.02l-239.64-40.91c-0.82-0.14-1.37-0.91-1.23-1.73c0.14-0.82,0.93-1.36,1.73-1.23 l239.64,40.91c0.82,0.14,1.37,0.91,1.23,1.73C567.54,593.63,566.9,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000170977623374399143130000002238176444267201417_",
    cx: -320.6239,
    cy: 179.4993,
    r: 87.4435,
    gradientTransform: "matrix(0.7654 -0.6436 0.6436 0.7654 576.242 228.4465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000170977623374399143130000002238176444267201417_)"
    },
    d: " M566.18,594.14c-0.08,0-0.17-0.01-0.25-0.02l-239.64-40.91c-0.82-0.14-1.37-0.91-1.23-1.73c0.14-0.82,0.93-1.36,1.73-1.23 l239.64,40.91c0.82,0.14,1.37,0.91,1.23,1.73C567.54,593.63,566.9,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000089561367116091086870000002602179033349480638_",
    filterUnits: "userSpaceOnUse",
    x: 276.5,
    y: 516.96,
    width: 291.19,
    height: 77.19
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend139 || (_feBlend139 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 276.5,
    y: 516.96,
    width: 291.19,
    height: 77.19,
    id: "SVGID_00000168099363057345099400000009258863185456035729_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000089561367116091086870000002602179033349480638_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000106861496355422791050000011771883740118001316_",
    filterUnits: "userSpaceOnUse",
    x: 276.5,
    y: 516.96,
    width: 291.19,
    height: 77.19
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend140 || (_feBlend140 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask70 || (_mask70 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 276.5,
    y: 516.96,
    width: 291.19,
    height: 77.19,
    id: "SVGID_00000168099363057345099400000009258863185456035729_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000149369842801649160550000017476858739112206749_",
    cx: -255.963,
    cy: 224.5517,
    r: 106.711,
    gradientTransform: "matrix(0.816 -0.578 0.578 0.816 501.1688 224.3761)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000168099363057345099400000009258863185456035729_)",
      "fill": "url(#SVGID_00000149369842801649160550000017476858739112206749_)"
    },
    d: " M566.19,594.15c-0.12,0-0.25-0.01-0.38-0.05l-288.19-74.19c-0.8-0.21-1.29-1.02-1.08-1.83c0.21-0.8,1.02-1.28,1.83-1.08 l288.19,74.19c0.8,0.21,1.29,1.02,1.08,1.83C567.47,593.7,566.86,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088103995105568567560000002912105147893002412_",
    cx: -255.963,
    cy: 224.5517,
    r: 106.711,
    gradientTransform: "matrix(0.816 -0.578 0.578 0.816 501.1688 224.3761)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000088103995105568567560000002912105147893002412_)"
    },
    d: " M566.19,594.15c-0.12,0-0.25-0.01-0.38-0.05l-288.19-74.19c-0.8-0.21-1.29-1.02-1.08-1.83c0.21-0.8,1.02-1.28,1.83-1.08 l288.19,74.19c0.8,0.21,1.29,1.02,1.08,1.83C567.47,593.7,566.86,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000129914128669083529030000016302742504619591856_",
    filterUnits: "userSpaceOnUse",
    x: 335.08,
    y: 511.25,
    width: 232.61,
    height: 82.89
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend141 || (_feBlend141 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 335.08,
    y: 511.25,
    width: 232.61,
    height: 82.89,
    id: "SVGID_00000160893678871815080320000015428474519953701782_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000129914128669083529030000016302742504619591856_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000090290550126854344420000007776603074517104574_",
    filterUnits: "userSpaceOnUse",
    x: 335.08,
    y: 511.25,
    width: 232.61,
    height: 82.89
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend142 || (_feBlend142 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask71 || (_mask71 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 335.08,
    y: 511.25,
    width: 232.61,
    height: 82.89,
    id: "SVGID_00000160893678871815080320000015428474519953701782_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000165199969724642181460000001665738334013610932_",
    cx: -151.8535,
    cy: 303.174,
    r: 87.4443,
    gradientTransform: "matrix(0.8611 -0.5085 0.5085 0.8611 427.9759 214.4151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000160893678871815080320000015428474519953701782_)",
      "fill": "url(#SVGID_00000165199969724642181460000001665738334013610932_)"
    },
    d: " M566.18,594.14c-0.16,0-0.33-0.03-0.49-0.08l-229.61-79.89c-0.78-0.27-1.2-1.13-0.92-1.91c0.27-0.78,1.12-1.2,1.91-0.92 l229.61,79.89c0.78,0.27,1.2,1.13,0.92,1.91C567.38,593.75,566.8,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000081611540298567134800000014511951976063807377_",
    cx: -151.8535,
    cy: 303.174,
    r: 87.4443,
    gradientTransform: "matrix(0.8611 -0.5085 0.5085 0.8611 427.9759 214.4151)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000081611540298567134800000014511951976063807377_)"
    },
    d: " M566.18,594.14c-0.16,0-0.33-0.03-0.49-0.08l-229.61-79.89c-0.78-0.27-1.2-1.13-0.92-1.91c0.27-0.78,1.12-1.2,1.91-0.92 l229.61,79.89c0.78,0.27,1.2,1.13,0.92,1.91C567.38,593.75,566.8,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000035519056797153898970000000369059756787616905_",
    filterUnits: "userSpaceOnUse",
    x: 292.69,
    y: 470.42,
    width: 275,
    height: 123.73
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend143 || (_feBlend143 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 292.69,
    y: 470.42,
    width: 275,
    height: 123.73,
    id: "SVGID_00000175294192161289427050000011771742142896095924_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000035519056797153898970000000369059756787616905_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000141420161583190942260000005841277041176458914_",
    filterUnits: "userSpaceOnUse",
    x: 292.69,
    y: 470.42,
    width: 275,
    height: 123.73
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend144 || (_feBlend144 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask72 || (_mask72 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 292.69,
    y: 470.42,
    width: 275,
    height: 123.73,
    id: "SVGID_00000175294192161289427050000011771742142896095924_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000100373644261811071240000005419784270619119268_",
    cx: -78.1083,
    cy: 333.8191,
    r: 106.7072,
    gradientTransform: "matrix(0.9002 -0.4355 0.4355 0.9002 355.1247 197.7684)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000175294192161289427050000011771742142896095924_)",
      "fill": "url(#SVGID_00000100373644261811071240000005419784270619119268_)"
    },
    d: " M566.19,594.15c-0.2,0-0.41-0.04-0.61-0.13l-272-120.73c-0.76-0.34-1.1-1.22-0.76-1.98c0.34-0.76,1.22-1.1,1.98-0.76 l272,120.73c0.76,0.34,1.1,1.22,0.76,1.98C567.31,593.82,566.76,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000015314399837683901960000017145381537792191920_",
    cx: -78.1083,
    cy: 333.8191,
    r: 106.7072,
    gradientTransform: "matrix(0.9002 -0.4355 0.4355 0.9002 355.1247 197.7684)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000015314399837683901960000017145381537792191920_)"
    },
    d: " M566.19,594.15c-0.2,0-0.41-0.04-0.61-0.13l-272-120.73c-0.76-0.34-1.1-1.22-0.76-1.98c0.34-0.76,1.22-1.1,1.98-0.76l272,120.73 c0.76,0.34,1.1,1.22,0.76,1.98C567.31,593.82,566.76,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000142134331638629162500000012393485659470724523_",
    filterUnits: "userSpaceOnUse",
    x: 351.41,
    y: 474.46,
    width: 216.28,
    height: 119.68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend145 || (_feBlend145 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 351.41,
    y: 474.46,
    width: 216.28,
    height: 119.68,
    id: "SVGID_00000176763154853963448910000012607481461033000367_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000142134331638629162500000012393485659470724523_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000119087906130167710700000013771769878702371492_",
    filterUnits: "userSpaceOnUse",
    x: 351.41,
    y: 474.46,
    width: 216.28,
    height: 119.68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend146 || (_feBlend146 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask73 || (_mask73 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 351.41,
    y: 474.46,
    width: 216.28,
    height: 119.68,
    id: "SVGID_00000176763154853963448910000012607481461033000367_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000078728987910929756420000017043169397012969624_",
    cx: 35.6085,
    cy: 397.0107,
    r: 87.4455,
    gradientTransform: "matrix(0.9332 -0.3594 0.3594 0.9332 283.6285 176.6075)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000176763154853963448910000012607481461033000367_)",
      "fill": "url(#SVGID_00000078728987910929756420000017043169397012969624_)"
    },
    d: " M566.18,594.14c-0.24,0-0.49-0.06-0.72-0.18L352.19,477.27c-0.73-0.4-0.99-1.31-0.6-2.04c0.4-0.73,1.31-0.99,2.04-0.6 L566.9,591.33c0.73,0.4,0.99,1.31,0.6,2.04C567.23,593.86,566.71,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138571206232859678020000012771601430612748449_",
    cx: 35.6085,
    cy: 397.0107,
    r: 87.4455,
    gradientTransform: "matrix(0.9332 -0.3594 0.3594 0.9332 283.6285 176.6075)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000138571206232859678020000012771601430612748449_)"
    },
    d: " M566.18,594.14c-0.24,0-0.49-0.06-0.72-0.18L352.19,477.27c-0.73-0.4-0.99-1.31-0.6-2.04c0.4-0.73,1.31-0.99,2.04-0.6 L566.9,591.33c0.73,0.4,0.99,1.31,0.6,2.04C567.23,593.86,566.71,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000032631520808985500080000012573426232576253574_",
    filterUnits: "userSpaceOnUse",
    x: 316.34,
    y: 427.2,
    width: 251.35,
    height: 166.96
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend147 || (_feBlend147 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 316.34,
    y: 427.2,
    width: 251.35,
    height: 166.96,
    id: "SVGID_00000086677560663652727400000011904053209057294231_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000032631520808985500080000012573426232576253574_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156565332538645331220000011567493506027802016_",
    filterUnits: "userSpaceOnUse",
    x: 316.34,
    y: 427.2,
    width: 251.35,
    height: 166.96
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend148 || (_feBlend148 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask74 || (_mask74 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 316.34,
    y: 427.2,
    width: 251.35,
    height: 166.96,
    id: "SVGID_00000086677560663652727400000011904053209057294231_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000141423865333070348270000003080339908979908788_",
    cx: 117.0623,
    cy: 411.7514,
    r: 106.7118,
    gradientTransform: "matrix(0.9597 -0.2809 0.2809 0.9597 214.0094 148.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000086677560663652727400000011904053209057294231_)",
      "fill": "url(#SVGID_00000141423865333070348270000003080339908979908788_)"
    },
    d: " M566.19,594.15c-0.28,0-0.57-0.08-0.83-0.25L317.02,429.95c-0.69-0.46-0.88-1.39-0.43-2.08c0.46-0.69,1.39-0.88,2.08-0.43 L567.02,591.4c0.69,0.46,0.88,1.39,0.43,2.08C567.15,593.92,566.67,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000106842381534286440200000000553312349333120407_",
    cx: 117.0623,
    cy: 411.7514,
    r: 106.7118,
    gradientTransform: "matrix(0.9597 -0.2809 0.2809 0.9597 214.0094 148.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000106842381534286440200000000553312349333120407_)"
    },
    d: " M566.19,594.15c-0.28,0-0.57-0.08-0.83-0.25L317.02,429.95c-0.69-0.46-0.88-1.39-0.43-2.08c0.46-0.69,1.39-0.88,2.08-0.43 L567.02,591.4c0.69,0.46,0.88,1.39,0.43,2.08C567.15,593.92,566.67,594.15,566.19,594.15z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000108306766276132777630000007486806171579388318_",
    filterUnits: "userSpaceOnUse",
    x: 373.58,
    y: 440.86,
    width: 194.1,
    height: 153.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend149 || (_feBlend149 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 373.58,
    y: 440.86,
    width: 194.1,
    height: 153.28,
    id: "SVGID_00000165198021373740458070000002885776663960748988_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000108306766276132777630000007486806171579388318_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000137848134783548390480000016641225408648049283_",
    filterUnits: "userSpaceOnUse",
    x: 373.58,
    y: 440.86,
    width: 194.1,
    height: 153.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend150 || (_feBlend150 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask75 || (_mask75 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 373.58,
    y: 440.86,
    width: 194.1,
    height: 153.28,
    id: "SVGID_00000165198021373740458070000002885776663960748988_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000018915148857108285990000016494923890195635849_",
    cx: 235.544,
    cy: 459.0235,
    r: 87.4464,
    gradientTransform: "matrix(0.9797 -0.2005 0.2005 0.9797 147.8362 115.0249)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000165198021373740458070000002885776663960748988_)",
      "fill": "url(#SVGID_00000018915148857108285990000016494923890195635849_)"
    },
    d: " M566.18,594.14c-0.32,0-0.65-0.1-0.93-0.32l-191.1-150.28c-0.65-0.51-0.76-1.46-0.25-2.11c0.51-0.65,1.46-0.77,2.11-0.25 l191.1,150.28c0.65,0.51,0.76,1.46,0.25,2.11C567.07,593.95,566.63,594.14,566.18,594.14z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000121240906288254315270000014065186862684514197_",
    cx: 235.544,
    cy: 459.0235,
    r: 87.4464,
    gradientTransform: "matrix(0.9797 -0.2005 0.2005 0.9797 147.8362 115.0249)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000121240906288254315270000014065186862684514197_)"
    },
    d: " M566.18,594.14c-0.32,0-0.65-0.1-0.93-0.32l-191.1-150.28c-0.65-0.51-0.76-1.46-0.25-2.11c0.51-0.65,1.46-0.77,2.11-0.25 l191.1,150.28c0.65,0.51,0.76,1.46,0.25,2.11C567.07,593.95,566.63,594.14,566.18,594.14z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000157995064568617446230000001078197825894308794_",
    filterUnits: "userSpaceOnUse",
    x: 346.8,
    y: 388.47,
    width: 220.89,
    height: 205.69
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend151 || (_feBlend151 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 346.8,
    y: 388.47,
    width: 220.89,
    height: 205.69,
    id: "SVGID_00000041988545938238879590000002770413126211088054_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000157995064568617446230000001078197825894308794_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000132774681271652573920000017336937307002044567_",
    filterUnits: "userSpaceOnUse",
    x: 346.8,
    y: 388.47,
    width: 220.89,
    height: 205.69
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend152 || (_feBlend152 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask76 || (_mask76 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 346.8,
    y: 388.47,
    width: 220.89,
    height: 205.69,
    id: "SVGID_00000041988545938238879590000002770413126211088054_"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000151515305267627378750000016919776934248770748_",
    cx: 321.3745,
    cy: 456.8335,
    r: 106.7108,
    gradientTransform: "matrix(0.9929 -0.1187 0.1187 0.9929 83.9254 75.8669)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "mask": "url(#SVGID_00000041988545938238879590000002770413126211088054_)",
      "fill": "url(#SVGID_00000151515305267627378750000016919776934248770748_)"
    },
    d: " M566.19,594.15c-0.37,0-0.73-0.13-1.02-0.4L347.28,391.06c-0.61-0.56-0.64-1.51-0.08-2.12c0.57-0.61,1.51-0.64,2.12-0.08 l217.89,202.69c0.61,0.56,0.64,1.51,0.08,2.12C566.99,593.99,566.59,594.15,566.19,594.15z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000032610294391223444880000000716408013942687403_",
    cx: 321.3745,
    cy: 456.8335,
    r: 106.7108,
    gradientTransform: "matrix(0.9929 -0.1187 0.1187 0.9929 83.9254 75.8669)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "clipPath": "url(#SVGID_00000067219826029419433110000003492426435685847474_)",
      "fill": "url(#SVGID_00000032610294391223444880000000716408013942687403_)"
    },
    d: " M566.19,594.15c-0.37,0-0.73-0.13-1.02-0.4L347.28,391.06c-0.61-0.56-0.64-1.51-0.08-2.12c0.57-0.61,1.51-0.64,2.12-0.08 l217.89,202.69c0.61,0.56,0.64,1.51,0.08,2.12C566.99,593.99,566.59,594.15,566.19,594.15z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000101068998917940118250000002893265502851975584_",
    filterUnits: "userSpaceOnUse",
    x: 202.76,
    y: 239.64,
    width: 716.48,
    height: 716.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend153 || (_feBlend153 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 202.76,
    y: 239.64,
    width: 716.48,
    height: 716.48,
    id: "SVGID_00000026156612782035010400000005774421285242526091_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000101068998917940118250000002893265502851975584_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000171699303082553449390000013229379290698139021_",
    filterUnits: "userSpaceOnUse",
    x: 202.76,
    y: 239.64,
    width: 716.48,
    height: 716.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend154 || (_feBlend154 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask77 || (_mask77 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 202.76,
    y: 239.64,
    width: 716.48,
    height: 716.48,
    id: "SVGID_00000026156612782035010400000005774421285242526091_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104681910765392359730000008813211645550502819_",
    gradientUnits: "userSpaceOnUse",
    x1: 3616.4841,
    y1: -593.1642,
    x2: 4332.96,
    y2: -593.1642,
    gradientTransform: "matrix(0 -1 1 0 1154.1643 4572.6001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718,
    style: {
      "stopColor": "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    style: {
      "stopColor": "#A5A5A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3593,
    style: {
      "stopColor": "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      "stopColor": "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      "stopColor": "#292929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7674,
    style: {
      "stopColor": "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      "stopColor": "#050505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "mask": "url(#SVGID_00000026156612782035010400000005774421285242526091_)",
      "fill": "url(#SVGID_00000104681910765392359730000008813211645550502819_)"
    },
    d: " M561,956.12c-48.36,0-95.28-9.47-139.44-28.15c-42.66-18.04-80.97-43.87-113.87-76.77c-32.9-32.9-58.73-71.21-76.77-113.87 c-18.68-44.17-28.15-91.08-28.15-139.44c0-48.36,9.47-95.28,28.15-139.44c18.04-42.66,43.87-80.97,76.77-113.87 c32.9-32.9,71.21-58.73,113.87-76.77c44.17-18.68,91.08-28.15,139.44-28.15c48.36,0,95.28,9.47,139.44,28.15 c42.66,18.04,80.97,43.87,113.87,76.77c32.9,32.9,58.73,71.21,76.77,113.87c18.68,44.17,28.15,91.08,28.15,139.44 c0,48.36-9.47,95.28-28.15,139.44c-18.04,42.66-43.87,80.97-76.77,113.87c-32.9,32.9-71.21,58.73-113.87,76.77 C656.28,946.64,609.36,956.12,561,956.12z M561,242.64c-94.89,0-184.09,36.95-251.19,104.05s-104.05,156.3-104.05,251.19 s36.95,184.1,104.05,251.19S466.11,953.12,561,953.12s184.1-36.95,251.19-104.05s104.05-156.3,104.05-251.19 s-36.95-184.09-104.05-251.19S655.89,242.64,561,242.64z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169555961101186807850000015939081418476999350_",
    gradientUnits: "userSpaceOnUse",
    x1: 3616.4841,
    y1: -593.1642,
    x2: 4332.96,
    y2: -593.1642,
    gradientTransform: "matrix(0 -1 1 0 1154.1643 4572.6001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#D7B676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      "stopColor": "#BDA069"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    style: {
      "stopColor": "#8B7751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4114,
    style: {
      "stopColor": "#62553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5718,
    style: {
      "stopColor": "#423B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      "stopColor": "#2B2822"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    style: {
      "stopColor": "#1E1D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "fill": "url(#SVGID_00000169555961101186807850000015939081418476999350_)"
    },
    d: "M561,956.12 c-48.36,0-95.28-9.47-139.44-28.15c-42.66-18.04-80.97-43.87-113.87-76.77c-32.9-32.9-58.73-71.21-76.77-113.87 c-18.68-44.17-28.15-91.08-28.15-139.44c0-48.36,9.47-95.28,28.15-139.44c18.04-42.66,43.87-80.97,76.77-113.87 c32.9-32.9,71.21-58.73,113.87-76.77c44.17-18.68,91.08-28.15,139.44-28.15c48.36,0,95.28,9.47,139.44,28.15 c42.66,18.04,80.97,43.87,113.87,76.77c32.9,32.9,58.73,71.21,76.77,113.87c18.68,44.17,28.15,91.08,28.15,139.44 c0,48.36-9.47,95.28-28.15,139.44c-18.04,42.66-43.87,80.97-76.77,113.87c-32.9,32.9-71.21,58.73-113.87,76.77 C656.28,946.64,609.36,956.12,561,956.12z M561,242.64c-94.89,0-184.09,36.95-251.19,104.05s-104.05,156.3-104.05,251.19 s36.95,184.1,104.05,251.19S466.11,953.12,561,953.12s184.1-36.95,251.19-104.05s104.05-156.3,104.05-251.19 s-36.95-184.09-104.05-251.19S655.89,242.64,561,242.64z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000111880244420838918690000002173800134300963734_",
    filterUnits: "userSpaceOnUse",
    x: 233.86,
    y: 270.74,
    width: 654.28,
    height: 654.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend155 || (_feBlend155 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 233.86,
    y: 270.74,
    width: 654.28,
    height: 654.28,
    id: "SVGID_00000165225094394377105550000010012517051610737038_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000111880244420838918690000002173800134300963734_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000005969776653309833280000009895884113462347696_",
    filterUnits: "userSpaceOnUse",
    x: 233.86,
    y: 270.74,
    width: 654.28,
    height: 654.28
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend156 || (_feBlend156 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask78 || (_mask78 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 233.86,
    y: 270.74,
    width: 654.28,
    height: 654.28,
    id: "SVGID_00000165225094394377105550000010012517051610737038_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023998092752493999740000009080753088281830824_",
    gradientUnits: "userSpaceOnUse",
    x1: 1424.9015,
    y1: 4011.6001,
    x2: 2079.1836,
    y2: 4011.6001,
    gradientTransform: "matrix(0 1 -1 0 4572.6001 -1154.1643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718,
    style: {
      "stopColor": "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    style: {
      "stopColor": "#A5A5A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3593,
    style: {
      "stopColor": "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      "stopColor": "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      "stopColor": "#292929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7674,
    style: {
      "stopColor": "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      "stopColor": "#050505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "mask": "url(#SVGID_00000165225094394377105550000010012517051610737038_)",
      "fill": "url(#SVGID_00000023998092752493999740000009080753088281830824_)"
    },
    d: " M561,925.02c-87.38,0-169.54-34.03-231.32-95.82c-61.79-61.79-95.82-143.94-95.82-231.32s34.03-169.54,95.82-231.32 c61.79-61.79,143.94-95.82,231.32-95.82s169.54,34.03,231.32,95.82c61.79,61.79,95.82,143.94,95.82,231.32 s-34.03,169.54-95.82,231.32C730.53,890.99,648.38,925.02,561,925.02z M561,273.74c-86.58,0-167.98,33.72-229.2,94.94 c-61.22,61.22-94.94,142.62-94.94,229.2c0,86.58,33.72,167.98,94.94,229.2c61.22,61.22,142.62,94.94,229.2,94.94 c86.58,0,167.98-33.72,229.2-94.94c61.22-61.22,94.94-142.62,94.94-229.2c0-86.58-33.72-167.98-94.94-229.2 C728.98,307.45,647.58,273.74,561,273.74z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041985487607079940120000016974061583516671399_",
    gradientUnits: "userSpaceOnUse",
    x1: 1424.9015,
    y1: 4011.6001,
    x2: 2079.1836,
    y2: 4011.6001,
    gradientTransform: "matrix(0 1 -1 0 4572.6001 -1154.1643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#D7B676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      "stopColor": "#BDA069"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    style: {
      "stopColor": "#8B7751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4114,
    style: {
      "stopColor": "#62553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5718,
    style: {
      "stopColor": "#423B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      "stopColor": "#2B2822"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    style: {
      "stopColor": "#1E1D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "fill": "url(#SVGID_00000041985487607079940120000016974061583516671399_)"
    },
    d: "M561,925.02 c-87.38,0-169.54-34.03-231.32-95.82c-61.79-61.79-95.82-143.94-95.82-231.32s34.03-169.54,95.82-231.32 c61.79-61.79,143.94-95.82,231.32-95.82s169.54,34.03,231.32,95.82c61.79,61.79,95.82,143.94,95.82,231.32 s-34.03,169.54-95.82,231.32C730.53,890.99,648.38,925.02,561,925.02z M561,273.74c-86.58,0-167.98,33.72-229.2,94.94 c-61.22,61.22-94.94,142.62-94.94,229.2c0,86.58,33.72,167.98,94.94,229.2c61.22,61.22,142.62,94.94,229.2,94.94 c86.58,0,167.98-33.72,229.2-94.94c61.22-61.22,94.94-142.62,94.94-229.2c0-86.58-33.72-167.98-94.94-229.2 C728.98,307.45,647.58,273.74,561,273.74z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000040572941213748194310000011821118973036821935_",
    filterUnits: "userSpaceOnUse",
    x: 262.71,
    y: 299.58,
    width: 596.59,
    height: 596.59
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend157 || (_feBlend157 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 262.71,
    y: 299.58,
    width: 596.59,
    height: 596.59,
    id: "SVGID_00000152233564891220456520000018337859474502593423_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000040572941213748194310000011821118973036821935_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000071536777962619567540000007572088291477871762_",
    filterUnits: "userSpaceOnUse",
    x: 262.71,
    y: 299.58,
    width: 596.59,
    height: 596.59
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend158 || (_feBlend158 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask79 || (_mask79 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 262.71,
    y: 299.58,
    width: 596.59,
    height: 596.59,
    id: "SVGID_00000152233564891220456520000018337859474502593423_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008857097078088503840000013799351505879714206_",
    gradientUnits: "userSpaceOnUse",
    x1: 1722.9851,
    y1: -704.5818,
    x2: 2319.5769,
    y2: -704.5818,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 -370.0379 2525.3354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0718,
    style: {
      "stopColor": "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    style: {
      "stopColor": "#A5A5A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3593,
    style: {
      "stopColor": "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      "stopColor": "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      "stopColor": "#292929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7674,
    style: {
      "stopColor": "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      "stopColor": "#050505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "mask": "url(#SVGID_00000152233564891220456520000018337859474502593423_)",
      "fill": "url(#SVGID_00000008857097078088503840000013799351505879714206_)"
    },
    d: " M561,896.17c-79.68,0-154.59-31.03-210.93-87.37c-56.34-56.34-87.37-131.25-87.37-210.92c0-79.68,31.03-154.58,87.37-210.92 c56.34-56.34,131.25-87.37,210.93-87.37c79.68,0,154.58,31.03,210.92,87.37c56.34,56.34,87.37,131.25,87.37,210.92 c0,79.68-31.03,154.59-87.37,210.92C715.59,865.14,640.68,896.17,561,896.17z M561,302.58c-78.88,0-153.03,30.72-208.8,86.49 S265.71,519,265.71,597.88c0,78.88,30.72,153.03,86.49,208.8c55.77,55.77,129.93,86.49,208.8,86.49 c78.88,0,153.03-30.72,208.8-86.49c55.77-55.77,86.49-129.93,86.49-208.8c0-78.88-30.71-153.03-86.49-208.8 C714.03,333.3,639.88,302.58,561,302.58z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178180604083546615800000003892710009129527191_",
    gradientUnits: "userSpaceOnUse",
    x1: 1722.9851,
    y1: -704.5818,
    x2: 2319.5769,
    y2: -704.5818,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 -370.0379 2525.3354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#D7B676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0795,
    style: {
      "stopColor": "#BDA069"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    style: {
      "stopColor": "#8B7751"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4114,
    style: {
      "stopColor": "#62553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5718,
    style: {
      "stopColor": "#423B2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7262,
    style: {
      "stopColor": "#2B2822"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8719,
    style: {
      "stopColor": "#1E1D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#191919"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "fill": "url(#SVGID_00000178180604083546615800000003892710009129527191_)"
    },
    d: "M561,896.17 c-79.68,0-154.59-31.03-210.93-87.37c-56.34-56.34-87.37-131.25-87.37-210.92c0-79.68,31.03-154.58,87.37-210.92 c56.34-56.34,131.25-87.37,210.93-87.37c79.68,0,154.58,31.03,210.92,87.37c56.34,56.34,87.37,131.25,87.37,210.92 c0,79.68-31.03,154.59-87.37,210.92C715.59,865.14,640.68,896.17,561,896.17z M561,302.58c-78.88,0-153.03,30.72-208.8,86.49 S265.71,519,265.71,597.88c0,78.88,30.72,153.03,86.49,208.8c55.77,55.77,129.93,86.49,208.8,86.49 c78.88,0,153.03-30.72,208.8-86.49c55.77-55.77,86.49-129.93,86.49-208.8c0-78.88-30.71-153.03-86.49-208.8 C714.03,333.3,639.88,302.58,561,302.58z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000109020945622243714920000010271787815774786735_",
    filterUnits: "userSpaceOnUse",
    x: 519.93,
    y: 233.03,
    width: 79.4,
    height: 79.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend159 || (_feBlend159 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 519.93,
    y: 233.03,
    width: 79.4,
    height: 79.4,
    id: "SVGID_00000075856715494459007760000014176822182522954938_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000109020945622243714920000010271787815774786735_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000176023784960117652380000003251242426958451845_",
    filterUnits: "userSpaceOnUse",
    x: 519.93,
    y: 233.03,
    width: 79.4,
    height: 79.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend160 || (_feBlend160 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask80 || (_mask80 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 519.93,
    y: 233.03,
    width: 79.4,
    height: 79.4,
    id: "SVGID_00000075856715494459007760000014176822182522954938_"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000085951459414139376080000000630901083878703775_",
    filterUnits: "userSpaceOnUse",
    x: 522.67,
    y: 883.32,
    width: 79.4,
    height: 79.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend161 || (_feBlend161 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 522.67,
    y: 883.32,
    width: 79.4,
    height: 79.4,
    id: "SVGID_00000042017967555699218030000009746171384065181119_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      "filter": "url(#Adobe_OpacityMaskFilter_00000085951459414139376080000000630901083878703775_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000142168270712838066580000010955636950950956709_",
    filterUnits: "userSpaceOnUse",
    x: 522.67,
    y: 883.32,
    width: 79.4,
    height: 79.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend162 || (_feBlend162 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask81 || (_mask81 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 522.67,
    y: 883.32,
    width: 79.4,
    height: 79.4,
    id: "SVGID_00000042017967555699218030000009746171384065181119_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112616104887950685260000000567202520540638383_",
    gradientUnits: "userSpaceOnUse",
    x1: 5135.7485,
    y1: 3028.7786,
    x2: 5215.1504,
    y2: 3028.7786,
    gradientTransform: "matrix(-1 0 0 -1 5737.8203 3951.8032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    style: {
      "stopColor": "#BABABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9401,
    style: {
      "stopColor": "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#000000"
    }
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057133659411292269850000018185138658479269533_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.4605,
    y1: 597.8782,
    x2: 799.5397,
    y2: 597.8782
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "brainPath",
    style: {
      "fill": "url(#SVGID_00000057133659411292269850000018185138658479269533_)"
    },
    d: "M561,836.42 c-63.72,0-123.62-24.81-168.67-69.87c-45.05-45.05-69.87-104.96-69.87-168.67c0-63.72,24.81-123.62,69.87-168.67 c45.05-45.05,104.96-69.87,168.67-69.87c63.72,0,123.62,24.81,168.67,69.87c45.05,45.05,69.87,104.96,69.87,168.67 c0,63.72-24.81,123.62-69.87,168.67C684.62,811.61,624.72,836.42,561,836.42z M393.39,430.27l1.06,1.06 c-44.49,44.49-68.99,103.64-68.99,166.55c0,62.92,24.5,122.06,68.99,166.55c44.49,44.49,103.64,68.99,166.55,68.99 c62.91,0,122.06-24.5,166.55-68.99c44.49-44.49,68.99-103.64,68.99-166.55c0-62.91-24.5-122.06-68.99-166.55 c-44.49-44.49-103.64-68.99-166.55-68.99c-62.92,0-122.06,24.5-166.55,68.99L393.39,430.27z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000168803642308299552550000000019581613138565511_",
    filterUnits: "userSpaceOnUse",
    x: 846.45,
    y: 556.81,
    width: 79.4,
    height: 79.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend163 || (_feBlend163 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))))));
};

export default __webpack_public_path__ + "static/media/main.dded7567.svg";
export { SvgComponent as ReactComponent };